import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../components/Header";
import { subscribeToCountsRealtime } from "../utils/countsService";
import { newIdempotencyKey, downloadCountFrom } from "../utils/downloadsService";
import { authHeaders } from "../utils/auth";
import { BACKEND_URL } from "../utils/api";
import PrefillBanner from "../components/PrefillBanner";
import { usePrefill } from "../context/PrefillContext";
import { toCommonFormFields } from "../utils/lextriaMapping";
import { saveAs } from "file-saver";
import JSZip from "jszip";

function UnifiedFormPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { selectedForms } = location.state || { selectedForms: [] };

  // Redirect if no forms selected
  useEffect(() => {
    if (!selectedForms || selectedForms.length === 0) {
      alert("No forms selected. Redirecting to form selector.");
      navigate("/");
    }
  }, [selectedForms, navigate]);

  const [loading, setLoading] = useState(false);
  const [counts, setCounts] = useState({});

  // Lextria Dashboard import: read once and used only as initial values (fields stay editable)
  const { prefill } = usePrefill();
  const [pf] = useState(() => toCommonFormFields(prefill));

  // Common fields (ALL FORMS)
  const [creatorName, setCreatorName] = useState(pf.creatorName || "Chaitra");
  const [trackingNumber, setTrackingNumber] = useState(pf.trackingNumber || "");
  const [title, setTitle] = useState(pf.title || "");

  // Applicants array
  const [applicants, setApplicants] = useState(() => pf.applicants || [
    { name: "", nationality: "IN", country: "India", address: "" },
  ]);

  // Form 4 specific fields
  const [extensionMonths, setExtensionMonths] = useState("");
  const [sectionRule, setSectionRule] = useState("");
  const [reasonForRequest, setReasonForRequest] = useState("");

  // Form 8 specific fields
  const [declarationType, setDeclarationType] = useState("state_claim");
  const [applicationDate, setApplicationDate] = useState("");
  const [madeBy, setMadeBy] = useState("");
  const [madeByDeclare, setMadeByDeclare] = useState("");
  const [inventorName, setInventorName] = useState("");
  const [inventorAddress, setInventorAddress] = useState("");
  const [inventorPostalCode, setInventorPostalCode] = useState("");
  const [inventorState, setInventorState] = useState("");
  const [inventorPhone, setInventorPhone] = useState("");
  const [inventorFax, setInventorFax] = useState("");
  // serviceAddressIndia - Now static in backend, no user input needed
  const [inventors, setInventors] = useState([{ name: "" }]);

  // Form-specific service address - REMOVED (now static in backend)

  // DEPRECATED - DO NOT USE - Use form-specific variables instead
  // const [patentNo, setPatentNo] = useState("");
  // const [requestDate, setRequestDate] = useState("");
  // const [signedPersonName, setSignedPersonName] = useState("");

  // Form 4 specific fields
  const [patentNo4, setPatentNo4] = useState(pf.applicationNo || "");
  const [requestDate4, setRequestDate4] = useState("");
  const [signedPersonName4, setSignedPersonName4] = useState("");

  // Form-specific to avoid cross-contamination
  const [patentNo8, setPatentNo8] = useState(pf.applicationNo || ""); // Form 8
  const [applicationDate8, setApplicationDate8] = useState(pf.applicationDate || ""); // Form 8
  const [requestDate8, setRequestDate8] = useState(""); // Form 8
  const [signedPersonName8, setSignedPersonName8] = useState(""); // Form 8

  const [applicationNo7A, setApplicationNo7A] = useState(""); // Form 7A
  const [applicationDate7A, setApplicationDate7A] = useState(""); // Form 7A
  const [signedPersonName7A, setSignedPersonName7A] = useState(""); // Form 7A

  const [patentNo9, setPatentNo9] = useState(pf.applicationNo || ""); // Form 9
  const [date9, setDate9] = useState(""); // Form 9
  const [requestDate9, setRequestDate9] = useState(""); // Form 9
  const [signedPersonName9, setSignedPersonName9] = useState(""); // Form 9

  const [patentNo10, setPatentNo10] = useState(""); // Form 10
  const [date10, setDate10] = useState(""); // Form 10
  const [signedPersonName10, setSignedPersonName10] = useState(""); // Form 10

  const [patentNo11, setPatentNo11] = useState(""); // Form 11
  const [date11, setDate11] = useState(""); // Form 11
  const [patentDate11, setPatentDate11] = useState(""); // Form 11
  const [signedPersonName11, setSignedPersonName11] = useState(""); // Form 11

  const [patentNo12, setPatentNo12] = useState(""); // Form 12
  const [date12, setDate12] = useState(""); // Form 12
  const [signedPersonName12, setSignedPersonName12] = useState(""); // Form 12

  const [patentNo13, setPatentNo13] = useState(pf.applicationNo || ""); // Form 13
  const [applicationDate13, setApplicationDate13] = useState(pf.applicationDate || ""); // Form 13
  const [date13, setDate13] = useState(""); // Form 13
  const [signedPersonName13, setSignedPersonName13] = useState(""); // Form 13

  const [patentNo14, setPatentNo14] = useState(""); // Form 14
  const [date14, setDate14] = useState(""); // Form 14
  const [signedPersonName14, setSignedPersonName14] = useState(""); // Form 14

  const [patentNo15, setPatentNo15] = useState(""); // Form 15
  const [date15, setDate15] = useState(""); // Form 15
  const [signedPersonName15, setSignedPersonName15] = useState(""); // Form 15

  // Form 7A specific fields - Already defined above (applicationNo7A, applicationDate7A, signedPersonName7A)
  const [publishedOn, setPublishedOn] = useState("");
  const [grounds, setGrounds] = useState("");
  const [madeBy7A, setMadeBy7A] = useState(""); // Form 7A specific

  // Form 8A specific fields
  const [inventor, setInventor] = useState("");
  const [patentNumber, setPatentNumber] = useState("");
  const [certificateType, setCertificateType] = useState("original"); // "original" or "duplicate"
  const [inventorOr, setInventorOr] = useState("");
  const [patentNumberOr, setPatentNumberOr] = useState("");
  const [aadhaarNumber, setAadhaarNumber] = useState("");
  const [houseNo, setHouseNo] = useState("");
  const [apartmentStreet, setApartmentStreet] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [country, setCountry] = useState("");
  const [pincode, setPincode] = useState("");
  const [mobilePhone, setMobilePhone] = useState("");
  const [email, setEmail] = useState("");
  const [date, setDate] = useState("");
  const [day, setDay] = useState("");
  const [year, setYear] = useState("");
  const [inventorSigned, setInventorSigned] = useState(""); // Name of inventor who signed

  // Form 9 specific fields
  const [dateNo, setDateNo] = useState("");

  // Form 10 specific fields
  const [grantedTo, setGrantedTo] = useState("");
  const [reason, setReason] = useState("");

  // Form 11 specific fields
  const [grantTo, setGrantTo] = useState("");

  // Form 12 specific fields
  const [highCourtName, setHighCourtName] = useState("");
  const [patentDate, setPatentDate] = useState(""); // DEPRECATED - will be removed
  const [patentDate12, setPatentDate12] = useState(""); // Form 12
  const [granteeName12, setGranteeName12] = useState(""); // Form 12 specific
  const [patenteeName12, setPatenteeName12] = useState(""); // Form 12 specific
  const [oppositionDate, setOppositionDate] = useState("");
  const [petitionNo, setPetitionNo] = useState("");
  const [petitionDate, setPetitionDate] = useState("");
  const [inventorNameForm12, setInventorNameForm12] = useState("");
  const [excludedClaims, setExcludedClaims] = useState("");
  const [trueInventorName, setTrueInventorName] = useState("");
  const [trueInventorAddress, setTrueInventorAddress] = useState("");
  const [trueInventorNationality, setTrueInventorNationality] = useState("");

  // Form 13 specific fields
  const [amendmentReason, setAmendmentReason] = useState("");

  // Form 14 specific fields
  const [oppositionType, setOppositionType] = useState("amendment"); // amendment, restoration, surrender, compulsory_license, license_revision, clerical_error
  const [patentDate14, setPatentDate14] = useState(""); // Form 14
  const [opponents, setOpponents] = useState([{ name: "", nationality: "", country: "", address: "" }]); // Form 14
  const [specificationNo, setSpecificationNo] = useState("");
  const [specificationDate, setSpecificationDate] = useState("");
  const [patentNoRelated, setPatentNoRelated] = useState("");
  const [patentDateRelated, setPatentDateRelated] = useState("");
  const [applicationNo14, setApplicationNo14] = useState(""); // Form 14 specific
  const [applicationDate14, setApplicationDate14] = useState(""); // Form 14 specific
  const [oppositionGrounds, setOppositionGrounds] = useState("");

  // Form 15 specific fields
  const [renewalYear, setRenewalYear] = useState("");
  const [patentDate15, setPatentDate15] = useState(""); // Form 15
  const [dueDate, setDueDate] = useState("");
  const [failureCircumstances, setFailureCircumstances] = useState("");

  // Form 6 specific fields
  const [patentNo6, setPatentNo6] = useState("");
  const [applicationDate6, setApplicationDate6] = useState("");
  const [originalApplicantName6, setOriginalApplicantName6] = useState("");
  const [reason6, setReason6] = useState("");
  const [documentsDescription6, setDocumentsDescription6] = useState("");
  // serviceAddressIndia6 - Removed (static in backend)
  const [date6, setDate6] = useState("");
  const [signedPersonName6, setSignedPersonName6] = useState("");

  // Form 7 specific fields
  const [opponents7, setOpponents7] = useState([{ name: "", nationality: "", country: "", address: "" }]);
  const [patentNo7, setPatentNo7] = useState("");
  const [applicationNo7, setApplicationNo7] = useState("");
  const [applicationDate7, setApplicationDate7] = useState("");
  const [publishedOn7, setPublishedOn7] = useState("");
  const [madeBy7, setMadeBy7] = useState(""); // Who made the patent (original applicant)
  const [grounds7, setGrounds7] = useState("");
  // serviceAddressIndia7 - Removed (static in backend)
  const [date7, setDate7] = useState("");
  const [signedPersonName7, setSignedPersonName7] = useState("");

  // Form 16 specific fields
  const [registrationType16, setRegistrationType16] = useState("transfer"); // "transfer" or "interest"
  const [patentNo16, setPatentNo16] = useState("");
  const [patentDate16, setPatentDate16] = useState("");
  const [granteeName16, setGranteeName16] = useState("");
  const [patenteeName16, setPatenteeName16] = useState("");
  const [documentType16, setDocumentType16] = useState("");
  // serviceAddressIndia16 - Removed (static in backend)
  const [date16, setDate16] = useState("");
  const [signedPersonName16, setSignedPersonName16] = useState("");

  // Form 17 specific fields
  const [patentNo17, setPatentNo17] = useState("");
  const [patentDate17, setPatentDate17] = useState("");
  const [granteeName17, setGranteeName17] = useState("");
  const [patenteeName17, setPatenteeName17] = useState("");
  const [grounds17, setGrounds17] = useState("");
  const [documentaryEvidence17, setDocumentaryEvidence17] = useState("");
  // serviceAddressIndia17 - Removed (static in backend)
  const [date17, setDate17] = useState("");
  const [signedPersonName17, setSignedPersonName17] = useState("");

  // Form 18 specific fields
  const [examinationType18, setExaminationType18] = useState("normal"); // "normal", "pct", "interested_person"
  const [patentNo18, setPatentNo18] = useState(pf.applicationNo || "");
  const [applicationDate18, setApplicationDate18] = useState(pf.applicationDate || "");
  const [inventionTitle18, setInventionTitle18] = useState(pf.title || "");
  const [pctApplicationNo18, setPctApplicationNo18] = useState("");
  const [pctFilingDate18, setPctFilingDate18] = useState("");
  const [pctCountry18, setPctCountry18] = useState("");
  const [interestedPersonName18, setInterestedPersonName18] = useState("");
  const [evidenceDocuments18, setEvidenceDocuments18] = useState("");
  // serviceAddressIndia18 - Removed (static in backend)
  const [date18, setDate18] = useState("");
  const [signedPersonName18, setSignedPersonName18] = useState("");

  // Form 18A specific fields
  const [expeditedType18A, setExpeditedType18A] = useState("normal"); // "normal", "pct", "conversion"
  const [patentNo18A, setPatentNo18A] = useState(pf.applicationNo || "");
  const [applicationDate18A, setApplicationDate18A] = useState(pf.applicationDate || "");
  const [inventionTitle18A, setInventionTitle18A] = useState(pf.title || "");
  const [pctApplicationNo18A, setPctApplicationNo18A] = useState("");
  const [pctFilingDate18A, setPctFilingDate18A] = useState("");
  const [pctCountry18A, setPctCountry18A] = useState("");
  const [requestExaminationNo18A, setRequestExaminationNo18A] = useState("");
  // serviceAddressIndia18A - Removed (static in backend)
  const [date18A, setDate18A] = useState("");
  const [signedPersonName18A, setSignedPersonName18A] = useState("");

  // Form 19 specific fields
  const [patentNo19, setPatentNo19] = useState("");
  const [patentDate19, setPatentDate19] = useState("");
  const [granteeName19, setGranteeName19] = useState("");
  const [patenteeName19, setPatenteeName19] = useState("");
  const [reason19, setReason19] = useState("");
  const [applicantInterest19, setApplicantInterest19] = useState("");
  const [documentaryEvidence19, setDocumentaryEvidence19] = useState("");
  // serviceAddressIndia19 - Removed (static in backend)
  const [date19, setDate19] = useState("");
  const [signedPersonName19, setSignedPersonName19] = useState("");

  // Form 20 specific fields
  const [patentNo20, setPatentNo20] = useState("");
  const [patentDate20, setPatentDate20] = useState("");
  const [granteeName20, setGranteeName20] = useState("");
  const [patenteeName20, setPatenteeName20] = useState("");
  const [licenceDate20, setLicenceDate20] = useState("");
  const [date20, setDate20] = useState("");
  const [signedPersonName20, setSignedPersonName20] = useState("");

  // Form 21 specific fields
  const [licenseGranteeName21, setLicenseGranteeName21] = useState("");
  const [controllerOrderDate21, setControllerOrderDate21] = useState("");
  const [patentNo21Under, setPatentNo21Under] = useState("");  // Patent number under license
  const [patentDate21Under, setPatentDate21Under] = useState("");  // Patent date under license
  const [originalGrantee21, setOriginalGrantee21] = useState("");
  const [patenteeName21, setPatenteeName21] = useState("");
  const [groundsForTermination21, setGroundsForTermination21] = useState("");
  const [documentaryEvidence21, setDocumentaryEvidence21] = useState("");
  // serviceAddressIndia21 - Removed (static in backend)
  const [date21, setDate21] = useState("");
  const [signedPersonName21, setSignedPersonName21] = useState("");

  // Form 22 specific fields
  const [characterCertificateFrom22, setCharacterCertificateFrom22] = useState("");
  const [fullName22, setFullName22] = useState("");
  const [addressResidence22, setAddressResidence22] = useState("");
  const [principalPlaceBusiness22, setPrincipalPlaceBusiness22] = useState("");
  const [branchOfficeAddress22, setBranchOfficeAddress22] = useState("");
  const [fathersName22, setFathersName22] = useState("");
  const [nationality22, setNationality22] = useState("IN");
  const [dateOfBirth22, setDateOfBirth22] = useState("");
  const [placeOfBirth22, setPlaceOfBirth22] = useState("");  // NEW: Place of birth
  const [occupation22, setOccupation22] = useState("");
  const [qualifications22, setQualifications22] = useState("");
  const [date22, setDate22] = useState("");
  const [signedPersonName22, setSignedPersonName22] = useState("");

  // Form 23 specific fields
  const [fullName23, setFullName23] = useState("");
  const [removalDate23, setRemovalDate23] = useState("");
  const [originalEntryDate23, setOriginalEntryDate23] = useState("");
  const [registrationNumber23, setRegistrationNumber23] = useState("");
  const [date23, setDate23] = useState("");
  const [signedPersonName23, setSignedPersonName23] = useState("");

  // Form 24 specific fields
  const [patentOrApplicationNo24, setPatentOrApplicationNo24] = useState(pf.applicationNo || "");
  const [relevantProceeding24, setRelevantProceeding24] = useState("");
  const [controllerDecisionDate24, setControllerDecisionDate24] = useState("");
  const [date24, setDate24] = useState("");
  const [signedPersonName24, setSignedPersonName24] = useState("");

  // Form 25 specific fields
  const [inventionTitle25, setInventionTitle25] = useState(pf.title || "");
  const [applicationNumber25, setApplicationNumber25] = useState(pf.applicationNo || "");
  const [applicationDate25, setApplicationDate25] = useState(pf.applicationDate || "");
  const [hasApplicationOrDescription25, setHasApplicationOrDescription25] = useState("has_application"); // "has_application" or "description"
  const [inventionDescription25, setInventionDescription25] = useState("");
  const [intendToApplyWith25, setIntendToApplyWith25] = useState("");
  const [targetCountries25, setTargetCountries25] = useState("");
  const [hasBeenAssigned25, setHasBeenAssigned25] = useState("no"); // "yes" or "no"
  const [assigneeName25, setAssigneeName25] = useState("");
  const [reasonsForApplication25, setReasonsForApplication25] = useState("");

  // Form 26 specific fields
  const [authorizerName26, setAuthorizerName26] = useState("");
  const [authorizerAddress26, setAuthorizerAddress26] = useState("");
  const [authorizedPersonName26, setAuthorizedPersonName26] = useState("");
  const [authorizedPersonAddress26, setAuthorizedPersonAddress26] = useState("");
  const [matterDescription26, setMatterDescription26] = useState("");
  const [signedPersonName26, setSignedPersonName26] = useState("");

  // Form 27 specific fields
  const [patentees27, setPatentees27] = useState([
    { name: "", nationality: "", address: "" },
  ]);
  const [patentNumbers27, setPatentNumbers27] = useState("");
  const [financialYear27, setFinancialYear27] = useState("");
  const [contactEmail27, setContactEmail27] = useState("");
  const [contactNumber27, setContactNumber27] = useState("");
  const [date27, setDate27] = useState("");

  // Form 29 specific fields
  const [applicationNumber29, setApplicationNumber29] = useState(pf.applicationNo || "");
  const [applicationDate29, setApplicationDate29] = useState(pf.applicationDate || "");
  const [examinationRequestNumber29, setExaminationRequestNumber29] = useState("");
  const [examinationRequestDate29, setExaminationRequestDate29] = useState("");
  const [date29, setDate29] = useState("");
  const [signedPersonName29, setSignedPersonName29] = useState("");
  const [designation29, setDesignation29] = useState("");

  // Form 30 specific fields
  const [applicantName30, setApplicantName30] = useState("");
  const [houseNo30, setHouseNo30] = useState("");
  const [street30, setStreet30] = useState("");
  const [city30, setCity30] = useState("");
  const [state30, setState30] = useState("");
  const [country30, setCountry30] = useState("");
  const [pincode30, setPincode30] = useState("");
  const [email30, setEmail30] = useState("");
  const [telephone30, setTelephone30] = useState("");
  const [mobile30, setMobile30] = useState("");
  const [fax30, setFax30] = useState("");
  const [applicationPatentNo30, setApplicationPatentNo30] = useState("");
  const [relevantSectionRules30, setRelevantSectionRules30] = useState("");
  const [purposeOfRequest30, setPurposeOfRequest30] = useState("");
  const [requestDetails30, setRequestDetails30] = useState("");
  const [signedPersonName30, setSignedPersonName30] = useState("");
  const [designation30, setDesignation30] = useState("");

  // Form 31 specific fields
  const [applicationNumber31, setApplicationNumber31] = useState(pf.applicationNo || "");
  const [applicationDate31, setApplicationDate31] = useState(pf.applicationDate || "");
  const [selectedGraceSections31, setSelectedGraceSections31] = useState([]); // Array: ["31a", "31b", "31c", "31d"]
  const [evidence31a, setEvidence31a] = useState("");
  const [evidence31b, setEvidence31b] = useState("");
  const [evidence31c, setEvidence31c] = useState("");
  const [evidence31d, setEvidence31d] = useState("");
  const [date31, setDate31] = useState("");

  // Subscribe to Firebase counts
  useEffect(() => {
    const unsubscribe = subscribeToCountsRealtime((data) => {
      setCounts(data);
    });
    return () => unsubscribe();
  }, []);

  // Applicant management
  const addApplicant = () =>
    setApplicants((prev) => [
      ...prev,
      { name: "", nationality: "IN", country: "India", address: "" },
    ]);

  const handleApplicantChange = (idx, field, value) => {
    setApplicants((prev) =>
      prev.map((a, i) => (i === idx ? { ...a, [field]: value } : a))
    );
  };

  const removeApplicant = (idx) =>
    setApplicants((prev) => prev.filter((_, i) => i !== idx));

  // Inventor management (Form 8)
  const addInventor = () => setInventors((prev) => [...prev, { name: "" }]);

  const handleInventorChange = (idx, value) => {
    setInventors((prev) =>
      prev.map((inv, i) => (i === idx ? { name: value } : inv))
    );
  };

  const removeInventor = (idx) =>
    setInventors((prev) => prev.filter((_, i) => i !== idx));

  // Patentee management (Form 27)
  const addPatentee27 = () =>
    setPatentees27((prev) => [
      ...prev,
      { name: "", nationality: "", address: "" },
    ]);

  const handlePatentee27Change = (idx, field, value) => {
    setPatentees27((prev) =>
      prev.map((p, i) => (i === idx ? { ...p, [field]: value } : p))
    );
  };

  const removePatentee27 = (idx) =>
    setPatentees27((prev) => prev.filter((_, i) => i !== idx));

  // Check which fields are needed based on selected forms
  const needsForm4Fields = selectedForms.includes("4");
  const needsForm8Fields = selectedForms.includes("8");
  const needsForm7AFields = selectedForms.includes("7A");
  const needsForm8AFields = selectedForms.includes("8A");
  const needsForm9Fields = selectedForms.includes("9");
  const needsForm10Fields = selectedForms.includes("10");
  const needsForm11Fields = selectedForms.includes("11");
  const needsForm12Fields = selectedForms.includes("12");
  const needsForm13Fields = selectedForms.includes("13");
  const needsForm14Fields = selectedForms.includes("14");
  const needsForm15Fields = selectedForms.includes("15");
  const needsForm6Fields = selectedForms.includes("6");
  const needsForm7Fields = selectedForms.includes("7");
  const needsForm16Fields = selectedForms.includes("16");
  const needsForm17Fields = selectedForms.includes("17");
  const needsForm18Fields = selectedForms.includes("18");
  const needsForm18AFields = selectedForms.includes("18A");
  const needsForm19Fields = selectedForms.includes("19");
  const needsForm20Fields = selectedForms.includes("20");
  const needsForm21Fields = selectedForms.includes("21");
  const needsForm22Fields = selectedForms.includes("22");
  const needsForm23Fields = selectedForms.includes("23");
  const needsForm24Fields = selectedForms.includes("24");
  const needsForm25Fields = selectedForms.includes("25");
  const needsForm26Fields = selectedForms.includes("26");
  const needsForm27Fields = selectedForms.includes("27");
  const needsForm29Fields = selectedForms.includes("29");
  const needsForm30Fields = selectedForms.includes("30");
  const needsForm31Fields = selectedForms.includes("31");

  const handleDownload = async () => {
    // Validation
    if (!trackingNumber.trim()) {
      alert("Please enter a tracking number.");
      return;
    }

    if (applicants.length === 0 || !applicants[0].name.trim()) {
      alert("Please enter at least one applicant name.");
      return;
    }

    // Form-specific validations
    if (needsForm4Fields) {
      if (!patentNo4.trim() || !extensionMonths || !sectionRule.trim() || 
          !reasonForRequest.trim() || !signedPersonName4.trim() || !requestDate4) {
        alert("Please fill all Form 4 required fields.");
        return;
      }
    }

    if (needsForm8Fields) {
      if (!patentNo8.trim() || !applicationDate8 || !signedPersonName8.trim() || 
          !requestDate8) {
        alert("Please fill all Form 8 required fields.");
        return;
      }
    }

    if (needsForm7AFields) {
      if (!applicationNo7A.trim() || !applicationDate7A || !madeBy7A.trim() || 
          !publishedOn || !grounds.trim() ||  
          !signedPersonName7A.trim()) {
        alert("Please fill all Form 7A required fields.");
        return;
      }
    }

    if (needsForm8AFields) {
      // Validate based on certificate type
      if (certificateType === "original") {
        if (!inventor.trim() || !patentNumber.trim() || !aadhaarNumber.trim() ||
            !houseNo.trim() || !apartmentStreet.trim() || !city.trim() || 
            !state.trim() || !country.trim() || !pincode.trim() || 
            !mobilePhone.trim() || !email.trim() || !date || !inventorSigned.trim()) {
          alert("Please fill all Form 8A required fields.");
          return;
        }
      } else { // duplicate
        if (!inventorOr.trim() || !patentNumberOr.trim() || !aadhaarNumber.trim() ||
            !houseNo.trim() || !apartmentStreet.trim() || !city.trim() || 
            !state.trim() || !country.trim() || !pincode.trim() || 
            !mobilePhone.trim() || !email.trim() || !date || !inventorSigned.trim()) {
          alert("Please fill all Form 8A required fields.");
          return;
        }
      }
    }

    if (needsForm9Fields) {
      if (!patentNo9.trim() || !date9 || !requestDate9 || !signedPersonName9.trim()) {
        alert("Please fill all Form 9 required fields.");
        return;
      }
    }

    if (needsForm10Fields) {
      if (!patentNo10.trim() || !date10 || !grantedTo.trim() || 
          !signedPersonName10.trim()) {
        alert("Please fill all Form 10 required fields.");
        return;
      }
    }

    if (needsForm11Fields) {
      if (!patentNo11.trim() || !patentDate11 || !date11 || !grantTo.trim() || !reason.trim() || 
          !signedPersonName11.trim()) {
        alert("Please fill all Form 11 required fields.");
        return;
      }
    }

    if (needsForm12Fields) {
      if (!highCourtName.trim() || !patentNo12.trim() || !patentDate12 || 
          !granteeName12.trim() || !patenteeName12.trim() ||
          !signedPersonName12.trim() || !date12) {
        alert("Please fill all Form 12 required fields.");
        return;
      }
    }

    if (needsForm13Fields) {
      if (!patentNo13.trim() || !applicationDate13 || !amendmentReason.trim() || 
          !date13 || !signedPersonName13.trim()) {
        alert("Please fill all Form 13 required fields.");
        return;
      }
    }

    if (needsForm14Fields) {
      if (!patentNo14.trim() || !patentDate14 || !oppositionGrounds.trim() || 
          !date14 || !signedPersonName14.trim()) {
        alert("Please fill all Form 14 required fields.");
        return;
      }
      // Validate opponents
      if (opponents.length === 0 || opponents.some(opp => !opp.name.trim() || !opp.nationality.trim() || !opp.country.trim() || !opp.address.trim())) {
        alert("Please fill all opponent details (name, nationality, country, address).");
        return;
      }
    }

    if (needsForm15Fields) {
      if (!patentNo15.trim() || !patentDate15 || !grantedTo.trim() || 
          !renewalYear.trim() || !dueDate || !failureCircumstances.trim() || 
          !date15 || !signedPersonName15.trim()) {
        alert("Please fill all Form 15 required fields.");
        return;
      }
    }

    if (needsForm6Fields) {
      if (!patentNo6.trim() || !applicationDate6 || !originalApplicantName6.trim() || 
          !reason6.trim() || !documentsDescription6.trim() ||
          !date6 || !signedPersonName6.trim()) {
        alert("Please fill all Form 6 required fields.");
        return;
      }
    }

    if (needsForm7Fields) {
      if (!patentNo7.trim() || !applicationNo7.trim() || !applicationDate7 || 
          !publishedOn7 || !madeBy7.trim() || !grounds7.trim() || 
          !date7 || !signedPersonName7.trim()) {
        alert("Please fill all Form 7 required fields.");
        return;
      }
      // Validate opponents for Form 7
      if (opponents7.length === 0 || opponents7.some(opp => !opp.name.trim() || !opp.nationality.trim() || !opp.country.trim() || !opp.address.trim())) {
        alert("Please fill all opponent details (name, nationality, country, address) for Form 7.");
        return;
      }
    }

    if (needsForm16Fields) {
      if (!patentNo16.trim() || !patentDate16 || !granteeName16.trim() || 
          !patenteeName16.trim() || !documentType16.trim() || 
          !date16 || !signedPersonName16.trim()) {
        alert("Please fill all Form 16 required fields.");
        return;
      }
    }

    if (needsForm17Fields) {
      if (!patentNo17.trim() || !patentDate17 || !granteeName17.trim() || 
          !patenteeName17.trim() || !grounds17.trim() || !documentaryEvidence17.trim() || 
          !date17 || !signedPersonName17.trim()) {
        alert("Please fill all Form 17 required fields.");
        return;
      }
    }

    if (needsForm18Fields) {
      if (!patentNo18.trim() || !applicationDate18 || !inventionTitle18.trim() || 
          !date18 || !signedPersonName18.trim()) {
        alert("Please fill all Form 18 required fields.");
        return;
      }
      if (examinationType18 === "pct") {
        if (!pctApplicationNo18.trim() || !pctFilingDate18 || !pctCountry18.trim()) {
          alert("Please fill all PCT-related fields for Form 18.");
          return;
        }
      }
      if (examinationType18 === "interested_person") {
        if (!interestedPersonName18.trim() || !evidenceDocuments18.trim()) {
          alert("Please fill interested person details for Form 18.");
          return;
        }
      }
    }

    if (needsForm18AFields) {
      if (!patentNo18A.trim() || !applicationDate18A || !inventionTitle18A.trim() || 
          !date18A || !signedPersonName18A.trim()) {
        alert("Please fill all Form 18A required fields.");
        return;
      }
      if (expeditedType18A === "pct") {
        if (!pctApplicationNo18A.trim() || !pctFilingDate18A || !pctCountry18A.trim()) {
          alert("Please fill all PCT-related fields for Form 18A.");
          return;
        }
      }
      if (expeditedType18A === "conversion") {
        if (!requestExaminationNo18A.trim()) {
          alert("Please fill request examination number for conversion in Form 18A.");
          return;
        }
      }
    }

    if (needsForm19Fields) {
      if (!patentNo19.trim() || !patentDate19 || !granteeName19.trim() || 
          !patenteeName19.trim() || !reason19.trim() || !applicantInterest19.trim() || 
          !documentaryEvidence19.trim() ||  
          !date19 || !signedPersonName19.trim()) {
        alert("Please fill all Form 19 required fields.");
        return;
      }
    }

    if (needsForm20Fields) {
      if (!patentNo20.trim() || !patentDate20 || !granteeName20.trim() || 
          !patenteeName20.trim() || !licenceDate20 || !date20 || !signedPersonName20.trim()) {
        alert("Please fill all Form 20 required fields.");
        return;
      }
    }

    if (needsForm21Fields) {
      if (!licenseGranteeName21.trim() || !controllerOrderDate21 || 
          !patentNo21Under.trim() || !patentDate21Under ||
          !originalGrantee21.trim() || !patenteeName21.trim() ||
          !groundsForTermination21.trim() || !documentaryEvidence21.trim() || 
          !date21 || !signedPersonName21.trim()) {
        alert("Please fill all Form 21 required fields.");
        return;
      }
    }

    if (needsForm22Fields) {
      if (!characterCertificateFrom22.trim() || !fullName22.trim() || 
          !addressResidence22.trim() || !principalPlaceBusiness22.trim() || 
          !fathersName22.trim() || !dateOfBirth22 || !placeOfBirth22.trim() || 
          !occupation22.trim() || !qualifications22.trim() || !date22 || !signedPersonName22.trim()) {
        alert("Please fill all Form 22 required fields.");
        return;
      }
    }

    if (needsForm23Fields) {
      if (!fullName23.trim() || !removalDate23 || !originalEntryDate23 || 
          !registrationNumber23.trim() || !date23 || !signedPersonName23.trim()) {
        alert("Please fill all Form 23 required fields.");
        return;
      }
    }

    if (needsForm24Fields) {
      if (!patentOrApplicationNo24.trim() || !relevantProceeding24.trim() || 
          !controllerDecisionDate24 || !date24 || !signedPersonName24.trim()) {
        alert("Please fill all Form 24 required fields.");
        return;
      }
    }

    if (needsForm25Fields) {
      if (!inventionTitle25.trim() || !targetCountries25.trim() || !reasonsForApplication25.trim()) {
        alert("Please fill all Form 25 required fields.");
        return;
      }
      if (hasApplicationOrDescription25 === "has_application") {
        if (!applicationNumber25.trim() || !applicationDate25) {
          alert("Please fill application number and date for Form 25.");
          return;
        }
      } else {
        if (!inventionDescription25.trim()) {
          alert("Please provide invention description for Form 25.");
          return;
        }
      }
      if (hasBeenAssigned25 === "yes") {
        if (!assigneeName25.trim()) {
          alert("Please fill assignee name for Form 25.");
          return;
        }
      }
    }

    if (needsForm26Fields) {
      if (!authorizerName26.trim() || !authorizerAddress26.trim() || !authorizedPersonName26.trim() || 
          !authorizedPersonAddress26.trim() || !matterDescription26.trim() || !signedPersonName26.trim()) {
        alert("Please fill all Form 26 required fields.");
        return;
      }
    }

    if (needsForm27Fields) {
      if (
        patentees27.length === 0 ||
        !patentees27[0].name.trim() ||
        !patentees27[0].nationality.trim() ||
        !patentees27[0].address.trim() ||
        !patentNumbers27.trim() ||
        !financialYear27.trim() ||
        !date27
      ) {
        alert("Please fill all Form 27 required fields (patentee name, nationality, address, patent numbers, financial year, and date).");
        return;
      }
    }

    if (needsForm29Fields) {
      if (!applicationNumber29.trim() || !applicationDate29 || !date29 || !signedPersonName29.trim()) {
        alert("Please fill all Form 29 required fields.");
        return;
      }
    }

    if (needsForm30Fields) {
      if (!applicantName30.trim() || !houseNo30.trim() || !city30.trim() || 
          !state30.trim() || !country30.trim() || !pincode30.trim() || 
          !applicationPatentNo30.trim() || !relevantSectionRules30.trim() || 
          !purposeOfRequest30.trim() || !requestDetails30.trim() || !signedPersonName30.trim()) {
        alert("Please fill all Form 30 required fields.");
        return;
      }
    }

    if (needsForm31Fields) {
      if (!applicationNumber31.trim() || !applicationDate31 || selectedGraceSections31.length === 0 || !date31) {
        alert("Please fill all Form 31 required fields and select at least one grace provision section.");
        return;
      }
      // Check if evidence is provided for selected sections
      if (selectedGraceSections31.includes("31a") && !evidence31a.trim()) {
        alert("Please provide documentary evidence for Section 31(a).");
        return;
      }
      if (selectedGraceSections31.includes("31b") && !evidence31b.trim()) {
        alert("Please provide documentary evidence for Section 31(b).");
        return;
      }
      if (selectedGraceSections31.includes("31c") && !evidence31c.trim()) {
        alert("Please provide documentary evidence for Section 31(c).");
        return;
      }
      if (selectedGraceSections31.includes("31d") && !evidence31d.trim()) {
        alert("Please provide documentary evidence for Section 31(d).");
        return;
      }
    }

    setLoading(true);

    try {
      const generatedFiles = [];

      // Generate each selected form
      for (const formNumber of selectedForms) {
        const response = await fetch(
          `${BACKEND_URL}/api/generate/${formNumber}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json", "Idempotency-Key": newIdempotencyKey(), ...(await authHeaders()) },
            body: JSON.stringify({
              creatorName,
              trackingNumber,
              title,
              applicants,
              ...(formNumber === "4" && {
                extension_months: extensionMonths,
                section_rule: sectionRule,
                reason_for_request: reasonForRequest,
                patent_no: patentNo4,
                request_date: requestDate4,
                signed_person_name: signedPersonName4,
              }),
              ...(formNumber === "8" && {
                declaration_type: declarationType,
                application_date: applicationDate8,
                made_by: declarationType === "state_claim" ? madeBy : "",
                made_by_declare: declarationType === "declare" ? madeByDeclare : "",
                patent_no: patentNo8,
                ...(declarationType === "state_claim" && {
                  inventors: inventors.map((inv) => ({ name: inv.name })),
                }),
                ...(declarationType === "declare" && {
                  inventor_name: inventorName,
                }),
                request_date: requestDate8,
                signed_person_name: signedPersonName8,
              }),
              ...(formNumber === "7A" && {
                application_no: applicationNo7A,
                application_date: applicationDate7A,
                made_by: madeBy7A,
                published_on: publishedOn,
                grounds: grounds,
                signed_person_name: signedPersonName7A,
              }),
              ...(formNumber === "8A" && {
                certificate_type: certificateType,
                inventor: certificateType === "original" ? inventor : "",
                patent_number: certificateType === "original" ? patentNumber : "",
                inventor_or: certificateType === "duplicate" ? inventorOr : "",
                patent_number_or: certificateType === "duplicate" ? patentNumberOr : "",
                aadhaar_number: aadhaarNumber,
                house_no: houseNo,
                apartment_street: apartmentStreet,
                city: city,
                state: state,
                country: country,
                pincode: pincode,
                mobile_phone: mobilePhone,
                email: email,
                date: date,
                inventor_signed: inventorSigned,
              }),
              ...(formNumber === "9" && {
                patent_no: patentNo9,
                date: date9,
                request_date: requestDate9,
                signature_person_name: signedPersonName9,
              }),
              ...(formNumber === "10" && {
                patent_no: patentNo10,
                date: date10,
                granted_to: grantedTo,

                signed_person_name: signedPersonName10,
              }),
              ...(formNumber === "11" && {
                patent_no: patentNo11,
                patent_date: patentDate11,
                date: date11,
                grant_to: grantTo,
                reason: reason,

                signed_person_name: signedPersonName11,
              }),
              ...(formNumber === "12" && {
                high_court_name: highCourtName,
                patent_no: patentNo12,
                patent_date: patentDate12,
                grantee_name: granteeName12,
                patentee_name: patenteeName12,
                opposition_date: oppositionDate,
                petition_no: petitionNo,
                petition_date: petitionDate,
                inventor_name: inventorNameForm12,
                excluded_claims: excludedClaims,
                true_inventor_name: trueInventorName,
                true_inventor_address: trueInventorAddress,
                true_inventor_nationality: trueInventorNationality,

                date: date12,
                signed_person_name: signedPersonName12,
              }),
              ...(formNumber === "13" && {
                patent_no: patentNo13,
                application_date: applicationDate13,
                amendment_reason: amendmentReason,
                date: date13,
                signed_person_name: signedPersonName13,
              }),
              ...(formNumber === "14" && {
                opposition_type: oppositionType,
                opponents: opponents,
                patent_no: patentNo14,
                patent_date: patentDate14,
                specification_no: oppositionType === "clerical_error" ? specificationNo : "",
                specification_date: oppositionType === "clerical_error" ? specificationDate : "",
                patent_no_related: oppositionType === "clerical_error" ? patentNoRelated : "",
                patent_date_related: oppositionType === "clerical_error" ? patentDateRelated : "",
                application_no: oppositionType === "clerical_error" ? applicationNo14 : "",
                application_date: oppositionType === "clerical_error" ? applicationDate14 : "",
                opposition_grounds: oppositionGrounds,

                date: date14,
                signed_person_name: signedPersonName14,
              }),
              ...(formNumber === "15" && {
                patent_no: patentNo15,
                patent_date: patentDate15,
                granted_to: grantedTo,
                renewal_year: renewalYear,
                due_date: dueDate,
                failure_circumstances: failureCircumstances,
                date: date15,
                signed_person_name: signedPersonName15,
              }),
              ...(formNumber === "6" && {
                patent_no: patentNo6,
                application_date: applicationDate6,
                original_applicant_name: originalApplicantName6,
                reason: reason6,
                documents_description: documentsDescription6,

                date: date6,
                signed_person_name: signedPersonName6,
              }),
              ...(formNumber === "7" && {
                opponents: opponents7,
                patent_no: patentNo7,
                application_no: applicationNo7,
                application_date: applicationDate7,
                published_on: publishedOn7,
                made_by: madeBy7,
                grounds: grounds7,

                date: date7,
                signed_person_name: signedPersonName7,
              }),
              ...(formNumber === "16" && {
                registration_type: registrationType16,
                patent_no: patentNo16,
                patent_date: patentDate16,
                grantee_name: granteeName16,
                patentee_name: patenteeName16,
                document_type: documentType16,

                date: date16,
                signed_person_name: signedPersonName16,
              }),
              ...(formNumber === "17" && {
                patent_no: patentNo17,
                patent_date: patentDate17,
                grantee_name: granteeName17,
                patentee_name: patenteeName17,
                grounds: grounds17,
                documentary_evidence: documentaryEvidence17,

                date: date17,
                signed_person_name: signedPersonName17,
              }),
              ...(formNumber === "18" && {
                examination_type: examinationType18,
                patent_no: patentNo18,
                application_date: applicationDate18,
                invention_title: inventionTitle18,
                pct_application_no: examinationType18 === "pct" ? pctApplicationNo18 : "",
                pct_filing_date: examinationType18 === "pct" ? pctFilingDate18 : "",
                pct_country: examinationType18 === "pct" ? pctCountry18 : "",
                interested_person_name: examinationType18 === "interested_person" ? interestedPersonName18 : "",
                evidence_documents: examinationType18 === "interested_person" ? evidenceDocuments18 : "",

                date: date18,
                signed_person_name: signedPersonName18,
              }),
              ...(formNumber === "18A" && {
                expedited_type: expeditedType18A,
                patent_no: patentNo18A,
                application_date: applicationDate18A,
                invention_title: inventionTitle18A,
                pct_application_no: expeditedType18A === "pct" ? pctApplicationNo18A : "",
                pct_filing_date: expeditedType18A === "pct" ? pctFilingDate18A : "",
                pct_country: expeditedType18A === "pct" ? pctCountry18A : "",
                request_examination_no: expeditedType18A === "conversion" ? requestExaminationNo18A : "",

                date: date18A,
                signed_person_name: signedPersonName18A,
              }),
              ...(formNumber === "19" && {
                patent_no: patentNo19,
                patent_date: patentDate19,
                grantee_name: granteeName19,
                patentee_name: patenteeName19,
                reason: reason19,
                applicant_interest: applicantInterest19,
                documentary_evidence: documentaryEvidence19,

                date: date19,
                signed_person_name: signedPersonName19,
              }),
              ...(formNumber === "20" && {
                patent_no: patentNo20,
                patent_date: patentDate20,
                grantee_name: granteeName20,
                patentee_name: patenteeName20,
                licence_date: licenceDate20,
                date: date20,
                signed_person_name: signedPersonName20,
              }),
              ...(formNumber === "21" && {
                license_grantee_name: licenseGranteeName21,
                controller_order_date: controllerOrderDate21,
                patent_no_21: patentNo21Under,
                patent_date_21: patentDate21Under,
                original_grantee: originalGrantee21,
                patentee_name_21: patenteeName21,
                grounds_for_termination: groundsForTermination21,
                documentary_evidence: documentaryEvidence21,

                date: date21,
                signed_person_name: signedPersonName21,
              }),
              ...(formNumber === "22" && {
                character_certificate_from: characterCertificateFrom22,
                full_name: fullName22,
                address_residence: addressResidence22,
                principal_place_business: principalPlaceBusiness22,
                branch_office_address: branchOfficeAddress22,
                fathers_name: fathersName22,
                nationality: nationality22,
                date_of_birth: dateOfBirth22,
                place_of_birth: placeOfBirth22,
                occupation: occupation22,
                qualifications: qualifications22,
                date: date22,
                signed_person_name: signedPersonName22,
              }),
              ...(formNumber === "23" && {
                full_name: fullName23,
                removal_date: removalDate23,
                original_entry_date: originalEntryDate23,
                registration_number: registrationNumber23,
                date: date23,
                signed_person_name: signedPersonName23,
              }),
              ...(formNumber === "24" && {
                patent_or_application_no: patentOrApplicationNo24,
                relevant_proceeding: relevantProceeding24,
                controller_decision_date: controllerDecisionDate24,
                date: date24,
                signed_person_name: signedPersonName24,
              }),
              ...(formNumber === "25" && {
                invention_title: inventionTitle25,
                application_number: hasApplicationOrDescription25 === "has_application" ? applicationNumber25 : "",
                application_date: hasApplicationOrDescription25 === "has_application" ? applicationDate25 : "",
                has_application_or_description: hasApplicationOrDescription25,
                invention_description: hasApplicationOrDescription25 === "description" ? inventionDescription25 : "",
                intend_to_apply_with: intendToApplyWith25,
                target_countries: targetCountries25,
                has_been_assigned: hasBeenAssigned25,
                assignee_name: hasBeenAssigned25 === "yes" ? assigneeName25 : "",
                reasons_for_application: reasonsForApplication25,
              }),
              ...(formNumber === "26" && {
                authorizer_name: authorizerName26,
                authorizer_address: authorizerAddress26,
                authorized_person_name: authorizedPersonName26,
                authorized_person_address: authorizedPersonAddress26,
                matter_description: matterDescription26,
                signed_person_name: signedPersonName26,
              }),
              ...(formNumber === "29" && {
                application_number: applicationNumber29,
                application_date: applicationDate29,
                examination_request_number: examinationRequestNumber29,
                examination_request_date: examinationRequestDate29,
                date: date29,
                signed_person_name: signedPersonName29,
                designation: designation29,
              }),
              ...(formNumber === "30" && {
                applicant_name: applicantName30,
                house_no: houseNo30,
                street: street30,
                city: city30,
                state: state30,
                country: country30,
                pincode: pincode30,
                email: email30,
                telephone: telephone30,
                mobile: mobile30,
                fax: fax30,
                application_patent_no: applicationPatentNo30,
                relevant_section_rules: relevantSectionRules30,
                purpose_of_request: purposeOfRequest30,
                request_details: requestDetails30,
                signed_person_name: signedPersonName30,
                designation: designation30,
              }),
              ...(formNumber === "31" && {
                application_number: applicationNumber31,
                application_date: applicationDate31,
                selected_grace_sections: selectedGraceSections31,
                evidence_31a: selectedGraceSections31.includes("31a") ? evidence31a : "",
                evidence_31b: selectedGraceSections31.includes("31b") ? evidence31b : "",
                evidence_31c: selectedGraceSections31.includes("31c") ? evidence31c : "",
                evidence_31d: selectedGraceSections31.includes("31d") ? evidence31d : "",
                date: date31,
              }),
            }),
          }
        );

        if (!response.ok) {
          throw new Error(`Form ${formNumber} generation failed: ${response.status}`);
        }

        const blob = await response.blob();
        generatedFiles.push({
          formNumber,
          blob,
          filename: `Form${formNumber}-filled.docx`,
        });

        // The backend records the download count and history
      }

      // Download logic: Single file or ZIP
      if (generatedFiles.length === 1) {
        // Single form: Direct download
        saveAs(generatedFiles[0].blob, generatedFiles[0].filename);
      } else {
        // Multiple forms: Create ZIP
        const zip = new JSZip();
        generatedFiles.forEach((file) => {
          zip.file(file.filename, file.blob);
        });

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const zipFilename = `Forms-${selectedForms.join("-")}-filled.zip`;
        saveAs(zipBlob, zipFilename);
      }
    } catch (error) {
      console.error("Error generating forms:", error);
      alert("Error generating forms: " + error.message);
    } finally {
      setLoading(false);
    }
  };
  
  // Helper function to build payload for any form
  const buildFormPayload = (formNumber) => {
    const basePayload = {
      creatorName,
      trackingNumber,
      title,
      applicants,
    };

    // Add form-specific fields based on formNumber
    const formSpecificData = {};

    switch(formNumber) {
      case "4":
        Object.assign(formSpecificData, {
          extension_months: extensionMonths,
          section_rule: sectionRule,
          reason_for_request: reasonForRequest,
          patent_no: patentNo4,
          request_date: requestDate4,
          signed_person_name: signedPersonName4,
        });
        break;
      
      case "7A":
        Object.assign(formSpecificData, {
          application_no: applicationNo7A,
          application_date: applicationDate7A,
          made_by: madeBy7A,
          published_on: publishedOn,
          grounds: grounds,

          signed_person_name: signedPersonName7A,
        });
        break;
      
      case "8":
        Object.assign(formSpecificData, {
          declaration_type: declarationType,
          application_date: applicationDate8,
          made_by: declarationType === "state_claim" ? madeBy : "",
          made_by_declare: declarationType === "declare" ? madeByDeclare : "",
          patent_no: patentNo8,
          ...(declarationType === "state_claim" && {
            inventors: inventors.map((inv) => ({ name: inv.name })),
          }),
          ...(declarationType === "declare" && {
            inventor_name: inventorName,
          }),

          request_date: requestDate8,
          signed_person_name: signedPersonName8,
        });
        break;

      case "8A":
        Object.assign(formSpecificData, {
          certificate_type: certificateType,
          inventor: certificateType === "original" ? inventor : "",
          patent_number: certificateType === "original" ? patentNumber : "",
          inventor_or: certificateType === "duplicate" ? inventorOr : "",
          patent_number_or: certificateType === "duplicate" ? patentNumberOr : "",
          aadhaar_number: aadhaarNumber,
          house_no: houseNo,
          apartment_street: apartmentStreet,
          city: city,
          state: state,
          country: country,
          pincode: pincode,
          mobile_phone: mobilePhone,
          email: email,
          date: date,
          inventor_signed: inventorSigned,
        });
        break;

      case "9":
        Object.assign(formSpecificData, {
          patent_no: patentNo9,
          date: date9,
          request_date: requestDate9,
          signature_person_name: signedPersonName9,
        });
        break;

      case "10":
        Object.assign(formSpecificData, {
          patent_no: patentNo10,
          date: date10,
          granted_to: grantedTo,

          signed_person_name: signedPersonName10,
        });
        break;

      case "11":
        Object.assign(formSpecificData, {
          patent_no: patentNo11,
          patent_date: patentDate11,
          date: date11,
          grant_to: grantTo,
          reason: reason,

          signed_person_name: signedPersonName11,
        });
        break;

      case "12":
        Object.assign(formSpecificData, {
          high_court_name: highCourtName,
          patent_no: patentNo12,
          patent_date: patentDate12,
          grantee_name: granteeName12,
          patentee_name: patenteeName12,
          opposition_date: oppositionDate,
          petition_no: petitionNo,
          petition_date: petitionDate,
          inventor_name: inventorNameForm12,
          excluded_claims: excludedClaims,
          true_inventor_name: trueInventorName,
          true_inventor_address: trueInventorAddress,
          true_inventor_nationality: trueInventorNationality,

          date: date12,
          signed_person_name: signedPersonName12,
        });
        break;

      case "13":
        Object.assign(formSpecificData, {
          patent_no: patentNo13,
          application_date: applicationDate13,
          amendment_reason: amendmentReason,
          date: date13,
          signed_person_name: signedPersonName13,
        });
        break;

      case "14":
        Object.assign(formSpecificData, {
          opposition_type: oppositionType,
          opponents: opponents,
          patent_no: patentNo14,
          patent_date: patentDate14,
          specification_no: oppositionType === "clerical_error" ? specificationNo : "",
          specification_date: oppositionType === "clerical_error" ? specificationDate : "",
          patent_no_related: oppositionType === "clerical_error" ? patentNoRelated : "",
          patent_date_related: oppositionType === "clerical_error" ? patentDateRelated : "",
          application_no: oppositionType === "clerical_error" ? applicationNo14 : "",
          application_date: oppositionType === "clerical_error" ? applicationDate14 : "",
          opposition_grounds: oppositionGrounds,

          date: date14,
          signed_person_name: signedPersonName14,
        });
        break;

      case "15":
        Object.assign(formSpecificData, {
          patent_no: patentNo15,
          patent_date: patentDate15,
          granted_to: grantedTo,
          renewal_year: renewalYear,
          due_date: dueDate,
          failure_circumstances: failureCircumstances,
          date: date15,
          signed_person_name: signedPersonName15,
        });
        break;

      case "6":
        Object.assign(formSpecificData, {
          patent_no: patentNo6,
          application_date: applicationDate6,
          original_applicant_name: originalApplicantName6,
          reason: reason6,
          documents_description: documentsDescription6,

          date: date6,
          signed_person_name: signedPersonName6,
        });
        break;

      case "7":
        Object.assign(formSpecificData, {
          opponents: opponents7,
          patent_no: patentNo7,
          application_no: applicationNo7,
          application_date: applicationDate7,
          published_on: publishedOn7,
          made_by: madeBy7,
          grounds: grounds7,

          date: date7,
          signed_person_name: signedPersonName7,
        });
        break;

      case "16":
        Object.assign(formSpecificData, {
          registration_type: registrationType16,
          patent_no: patentNo16,
          patent_date: patentDate16,
          grantee_name: granteeName16,
          patentee_name: patenteeName16,
          document_type: documentType16,

          date: date16,
          signed_person_name: signedPersonName16,
        });
        break;

      case "17":
        Object.assign(formSpecificData, {
          patent_no: patentNo17,
          patent_date: patentDate17,
          grantee_name: granteeName17,
          patentee_name: patenteeName17,
          grounds: grounds17,
          documentary_evidence: documentaryEvidence17,

          date: date17,
          signed_person_name: signedPersonName17,
        });
        break;

      case "18":
        Object.assign(formSpecificData, {
          examination_type: examinationType18,
          patent_no: patentNo18,
          application_date: applicationDate18,
          invention_title: inventionTitle18,
          pct_application_no: examinationType18 === "pct" ? pctApplicationNo18 : "",
          pct_filing_date: examinationType18 === "pct" ? pctFilingDate18 : "",
          pct_country: examinationType18 === "pct" ? pctCountry18 : "",
          interested_person_name: examinationType18 === "interested_person" ? interestedPersonName18 : "",
          evidence_documents: examinationType18 === "interested_person" ? evidenceDocuments18 : "",

          date: date18,
          signed_person_name: signedPersonName18,
        });
        break;

      case "18A":
        Object.assign(formSpecificData, {
          expedited_type: expeditedType18A,
          patent_no: patentNo18A,
          application_date: applicationDate18A,
          invention_title: inventionTitle18A,
          pct_application_no: expeditedType18A === "pct" ? pctApplicationNo18A : "",
          pct_filing_date: expeditedType18A === "pct" ? pctFilingDate18A : "",
          pct_country: expeditedType18A === "pct" ? pctCountry18A : "",
          request_examination_no: expeditedType18A === "conversion" ? requestExaminationNo18A : "",

          date: date18A,
          signed_person_name: signedPersonName18A,
        });
        break;

      case "19":
        Object.assign(formSpecificData, {
          patent_no: patentNo19,
          patent_date: patentDate19,
          grantee_name: granteeName19,
          patentee_name: patenteeName19,
          reason: reason19,
          applicant_interest: applicantInterest19,
          documentary_evidence: documentaryEvidence19,

          date: date19,
          signed_person_name: signedPersonName19,
        });
        break;

      case "20":
        Object.assign(formSpecificData, {
          patent_no: patentNo20,
          patent_date: patentDate20,
          grantee_name: granteeName20,
          patentee_name: patenteeName20,
          licence_date: licenceDate20,
          date: date20,
          signed_person_name: signedPersonName20,
        });
        break;

      case "21":
        Object.assign(formSpecificData, {
          license_grantee_name: licenseGranteeName21,
          controller_order_date: controllerOrderDate21,
          patent_no_21: patentNo21Under,
          patent_date_21: patentDate21Under,
          original_grantee: originalGrantee21,
          patentee_name_21: patenteeName21,
          grounds_for_termination: groundsForTermination21,
          documentary_evidence: documentaryEvidence21,

          date: date21,
          signed_person_name: signedPersonName21,
        });
        break;

      case "22":
        Object.assign(formSpecificData, {
          character_certificate_from: characterCertificateFrom22,
          full_name: fullName22,
          address_residence: addressResidence22,
          principal_place_business: principalPlaceBusiness22,
          branch_office_address: branchOfficeAddress22,
          fathers_name: fathersName22,
          nationality: nationality22,
          date_of_birth: dateOfBirth22,
          place_of_birth: placeOfBirth22,
          occupation: occupation22,
          qualifications: qualifications22,
          date: date22,
          signed_person_name: signedPersonName22,
        });
        break;

      case "23":
        Object.assign(formSpecificData, {
          patent_no: patentNo23,
          patent_date: patentDate23,
          grantee_name: granteeName23,
          patentee_name: patenteeName23,
          non_working_reason: nonWorkingReason23,
          working_details: workingDetails23,
          public_interest: publicInterest23,
          documentary_evidence: documentaryEvidence23,

          date: date23,
          signed_person_name: signedPersonName23,
        });
        break;

      case "24":
        Object.assign(formSpecificData, {
          patent_no: patentNo24,
          patent_date: patentDate24,
          grantee_name: granteeName24,
          patentee_name: patenteeName24,
          compulsory_licence_date: compulsoryLicenceDate24,
          grounds: grounds24,
          documentary_evidence: documentaryEvidence24,

          date: date24,
          signed_person_name: signedPersonName24,
        });
        break;

      case "25":
        Object.assign(formSpecificData, {
          invention_title: inventionTitle25,
          target_countries: targetCountries25,
          reasons_for_application: reasonsForApplication25,
          date: date25,
          signed_person_name: signedPersonName25,
        });
        break;

      case "26":
        Object.assign(formSpecificData, {
          patent_no: patentNo26,
          patent_date: patentDate26,
          grantee_name: granteeName26,
          patentee_name: patenteeName26,
          request_reason: requestReason26,

          date: date26,
          signed_person_name: signedPersonName26,
        });
        break;

      case "27":
        console.log("Form 27 - Patentees array:", patentees27);
        Object.assign(formSpecificData, {
          patentees: patentees27,  // Send array, let backend format it
          patent_numbers: patentNumbers27,
          financial_year: financialYear27,
          contact_email: contactEmail27,
          contact_number: contactNumber27,
          date: date27,
        });
        console.log("Form 27 - formSpecificData:", formSpecificData);
        break;

      case "28":
        Object.assign(formSpecificData, {
          application_type: applicationType28,
          application_no: applicationNo28,
          application_date: applicationDate28,
          patent_no: applicationType28 === "patent" ? patentNo28 : "",
          patent_date: applicationType28 === "patent" ? patentDate28 : "",
          priority_application_no: priorityApplicationNo28,
          priority_date: priorityDate28,
          priority_country: priorityCountry28,
          date: date28,
          signed_person_name: signedPersonName28,
        });
        break;

      case "29":
        Object.assign(formSpecificData, {
          application_no: applicationNo29,
          application_date: applicationDate29,
          invention_title: inventionTitle29,
          priority_application_no: priorityApplicationNo29,
          priority_date: priorityDate29,
          priority_country: priorityCountry29,
          date: date29,
          signed_person_name: signedPersonName29,
        });
        break;

      case "30":
        Object.assign(formSpecificData, {
          applicant_name: applicantName30,
          house_no: houseNo30,
          city: city30,
          state: state30,
          country: country30,
          pincode: pincode30,
          application_patent_no: applicationPatentNo30,
          relevant_section_rules: relevantSectionRules30,
          purpose_of_request: purposeOfRequest30,
          request_details: requestDetails30,
          date: date30,
          signed_person_name: signedPersonName30,
        });
        break;

      case "31":
        Object.assign(formSpecificData, {
          application_number: applicationNumber31,
          application_date: applicationDate31,
          selected_grace_sections: selectedGraceSections31,
          evidence_31a: selectedGraceSections31.includes("31a") ? evidence31a : "",
          evidence_31b: selectedGraceSections31.includes("31b") ? evidence31b : "",
          evidence_31c: selectedGraceSections31.includes("31c") ? evidence31c : "",
          evidence_31d: selectedGraceSections31.includes("31d") ? evidence31d : "",
          date: date31,
        });
        break;
    }

    return { ...basePayload, ...formSpecificData };
  };
  
  // Individual form download handler - generates and downloads single form
  // Check if basic form fields are filled (similar to Form135 isFormValid)
  const isFormValid = () => {
    return trackingNumber.trim() && 
           applicants.length > 0 && 
           applicants[0].name.trim();
  };

  const handleIndividualDownload = async (formNumber) => {
    // Validate required fields before download
    if (!trackingNumber.trim()) {
      alert("Please enter a tracking number before downloading.");
      return;
    }

    if (applicants.length === 0 || !applicants[0].name.trim()) {
      alert("Please enter at least one applicant name.");
      return;
    }

    // Form-specific validation (simplified - add more as needed)
    const needsForm4Fields = formNumber === "4";
    const needsForm7AFields = formNumber === "7A";
    const needsForm8Fields = formNumber === "8";

    if (needsForm4Fields) {
      if (!patentNo4.trim() || !extensionMonths || !sectionRule.trim() || 
          !reasonForRequest.trim() || !signedPersonName4.trim() || !requestDate4) {
        alert("Please fill all Form 4 required fields.");
        return;
      }
    }

    if (needsForm7AFields) {
      if (!applicationNo7A.trim() || !applicationDate7A || !madeBy7A.trim() || 
          !publishedOn || !grounds.trim() || 
          !signedPersonName7A.trim()) {
        alert("Please fill all Form 7A required fields.");
        return;
      }
    }

    if (needsForm8Fields) {
      if (!patentNo8.trim() || !applicationDate8 || !signedPersonName8.trim() || 
          !requestDate8) {
        alert("Please fill all Form 8 required fields.");
        return;
      }
    }

    setLoading(true);

    try {
      // Build payload using helper function
      const payload = buildFormPayload(formNumber);

      // Generate single form
      const response = await fetch(
        `${BACKEND_URL}/api/generate/${formNumber}`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "Idempotency-Key": newIdempotencyKey(), ...(await authHeaders()) },
          body: JSON.stringify(payload),
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      const filename = `FORM${formNumber}-filled.docx`;

      // The backend records the download count and history; show the new count
      const newCount = downloadCountFrom(response);
      if (newCount != null) {
        setCounts(prev => ({
          ...prev,
          [`FORM${formNumber}.docx`]: newCount
        }));
      }

      // Download file
      saveAs(blob, filename);
    } catch (error) {
      console.error(`Error generating form ${formNumber}:`, error);
      alert(`Error generating form ${formNumber}: ` + error.message);
    } finally {
      setLoading(false);
    }
  };

  if (!selectedForms || selectedForms.length === 0) {
    return null;
  }

  return (
    <>
      <Header />
      <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 py-10 px-4">
        <div className="max-w-4xl mx-auto bg-white p-10 rounded-2xl shadow-2xl border-2 border-blue-200">
          <PrefillBanner />
          {/* Header */}
          <div className="text-center border-b-4 border-blue-200 pb-6 mb-8">
            <h1 className="text-4xl md:text-5xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600 mb-4">
              Generate Multiple Forms
            </h1>
            <div className="flex flex-wrap justify-center gap-3 mt-4">
              {selectedForms.map((formNum) => (
                <span
                  key={formNum}
                  className="bg-gradient-to-r from-blue-500 to-indigo-500 text-white px-5 py-2 rounded-xl text-base font-bold shadow-md"
                >
                  Form {formNum}
                </span>
              ))}
            </div>
            <p className="text-gray-600 text-sm mt-3">
              Fill the form once, generate {selectedForms.length} document(s)
            </p>
          </div>

          {/* Form Fields */}
          <div className="space-y-8">
            {/* Common Fields Section */}
            <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg">
              <h2 className="text-2xl font-bold text-blue-900 mb-6">
                📋 Common Information (Required for all forms)
              </h2>

              {/* Creator Name */}
              <div className="mb-6">
                <label className="block text-base font-bold text-gray-800 mb-3">
                  Creator Name <span className="text-red-600">*</span>
                </label>
                <select
                  className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 focus:border-transparent shadow-sm"
                  value={creatorName}
                  onChange={(e) => setCreatorName(e.target.value)}
                >
                  {pf.creatorName && !["Chaitra", "Mounisha", "Lextria"].includes(pf.creatorName) && (
                    <option value={pf.creatorName}>{pf.creatorName}</option>
                  )}
                  <option value="Chaitra">Chaitra</option>
                  <option value="Mounisha">Mounisha</option>
                  <option value="Lextria">Lextria</option>
                </select>
              </div>

              {/* Tracking Number */}
              <div className="mb-6">
                <label className="block text-base font-bold text-gray-800 mb-3">
                  Tracking Number <span className="text-red-600">*</span>
                </label>
                <input
                  type="text"
                  placeholder="Enter tracking number"
                  className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 focus:border-transparent shadow-sm"
                  value={trackingNumber}
                  onChange={(e) => setTrackingNumber(e.target.value)}
                />
              </div>

              {/* Title */}
              <div className="mb-6">
                <label className="block text-base font-bold text-gray-800 mb-3">
                  Title of Invention
                </label>
                <input
                  type="text"
                  placeholder="Enter title of invention"
                  className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 focus:border-transparent shadow-sm"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                />
              </div>

              {/* Applicants */}
              <div className="border-3 border-blue-300 rounded-xl p-6 bg-white shadow-md">
                <div className="flex justify-between items-center mb-5">
                  <label className="text-base font-bold text-gray-800">
                    Applicant(s) <span className="text-red-600">*</span>
                  </label>
                  <button
                    type="button"
                    onClick={addApplicant}
                    className="px-5 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors font-bold text-base shadow-md hover:shadow-lg"
                  >
                    + Add Applicant
                  </button>
                </div>

                {applicants.map((applicant, idx) => (
                  <div
                    key={idx}
                    className="bg-gray-50 p-5 rounded-xl mb-4 border-2 border-gray-200 relative shadow-sm"
                  >
                    {applicants.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removeApplicant(idx)}
                        className="absolute top-3 right-3 text-red-600 hover:text-red-800 font-bold text-xl"
                        title="Remove applicant"
                      >
                        ✕
                      </button>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                      <div className="md:col-span-2">
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Name
                        </label>
                        <input
                          type="text"
                          placeholder="Applicant name"
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={applicant.name}
                          onChange={(e) =>
                            handleApplicantChange(idx, "name", e.target.value)
                          }
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Nationality
                        </label>
                        <input
                          type="text"
                          placeholder="IN"
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={applicant.nationality}
                          onChange={(e) =>
                            handleApplicantChange(idx, "nationality", e.target.value)
                          }
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Country
                        </label>
                        <input
                          type="text"
                          placeholder="India"
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={applicant.country}
                          onChange={(e) =>
                            handleApplicantChange(idx, "country", e.target.value)
                          }
                        />
                      </div>

                      <div className="md:col-span-2">
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Address
                        </label>
                        <textarea
                          rows="2"
                          placeholder="Complete address"
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
                          value={applicant.address}
                          onChange={(e) =>
                            handleApplicantChange(idx, "address", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Form 4 Specific Fields */}
            {needsForm4Fields && (
              <div className="bg-yellow-50 border-l-4 border-yellow-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-yellow-900 mb-6">
                  📝 Form 4: Request for Extension of Time
                </h2>

                <div className="space-y-6">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patent/Application Number <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g., 202010012345"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={patentNo4}
                      onChange={(e) => setPatentNo4(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Extension Months <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="number"
                      min="1"
                      placeholder="Number of months"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={extensionMonths}
                      onChange={(e) => setExtensionMonths(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Section/Rule <span className="text-red-600">*</span>
                    </label>
                    <select
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={sectionRule}
                      onChange={(e) => setSectionRule(e.target.value)}
                    >
                      <option value="">-- Choose Statutory Provision --</option>
                      <option value="Section 53(2) & Rule 80(1A)">Section 53(2) & Rule 80(1A) [Patent Renewal/Maintenance Fee]</option>
                      <option value="Section 142(4) & Rule 131(2)">Section 142(4) & Rule 131(2) [Statement of Working / Form 27]</option>
                      <option value="Rule 12(5)">Rule 12(5) [Foreign Application Details / Form 3]</option>
                      <option value="Rule 13(6)">Rule 13(6) [Declaration as to Inventorship]</option>
                      <option value="Rule 24B(6)">Rule 24B(6) [Standard Request for Examination]</option>
                      <option value="Rule 24C(11)">Rule 24C(11) [Expedited Request for Examination]</option>
                      <option value="Rule 130">Rule 130 [General Form Submissions & Amendments]</option>
                      <option value="Rule 138">Rule 138 [General Condonation of Delay / Timeline Extension]</option>
                    </select>
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Reason for Request <span className="text-red-600">*</span>
                    </label>
                    <textarea
                      placeholder="Provide reasons for extension request"
                      rows="4"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={reasonForRequest}
                      onChange={(e) => setReasonForRequest(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Request Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={requestDate4}
                      onChange={(e) => setRequestDate4(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Name of Person Who Signed <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Full name of person signing"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={signedPersonName4}
                      onChange={(e) => setSignedPersonName4(e.target.value)}
                    />
                  </div>
                </div>
              </div>
            )}

            {/* Form 8 Specific Fields */}
            {needsForm8Fields && (
              <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-purple-900 mb-6">
                  📝 Form 8: Request or Claim Regarding Mention of Inventor
                </h2>

                <div className="space-y-6">
                  {/* Declaration Type */}
                  <div className="bg-purple-100 border-3 border-purple-300 rounded-xl p-5 shadow-md">
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      What do you want to do? <span className="text-red-600">*</span>
                    </label>
                    <select
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                      value={declarationType}
                      onChange={(e) => setDeclarationType(e.target.value)}
                    >
                      <option value="state_claim">
                        ADD someone as inventor (they should be mentioned)
                      </option>
                      <option value="declare">
                        REMOVE someone as inventor (they should NOT be mentioned)
                      </option>
                    </select>

                    {declarationType === "state_claim" && (
                      <p className="mt-3 text-sm text-blue-800 bg-blue-100 p-4 rounded-lg font-medium">
                        📝 You are claiming that <strong>someone should be added</strong> as
                        an inventor in this patent application.
                      </p>
                    )}
                    {declarationType === "declare" && (
                      <p className="mt-3 text-sm text-red-800 bg-red-100 p-4 rounded-lg font-medium">
                        🚫 You are declaring that <strong>someone should be removed</strong>{" "}
                        as an inventor from this patent application.
                      </p>
                    )}
                  </div>

                  {/* Inventor Name - Dynamic based on ADD/REMOVE */}
                  {declarationType === "state_claim" ? (
                    <div className="bg-white border-3 border-indigo-300 rounded-xl p-5 shadow-md">
                      <div className="flex justify-between items-center mb-5">
                        <label className="text-base font-bold text-gray-800">
                          Name(s) of Inventor(s) to ADD <span className="text-red-600">*</span>
                        </label>
                        <button
                          type="button"
                          onClick={addInventor}
                          className="px-5 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors font-bold text-base shadow-md"
                        >
                          + Add Inventor
                        </button>
                      </div>

                      {inventors.map((inventor, idx) => (
                        <div
                          key={idx}
                          className="bg-gray-50 p-4 rounded-lg mb-3 border-2 border-gray-200 relative"
                        >
                          {inventors.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeInventor(idx)}
                              className="absolute top-2 right-2 text-red-600 hover:text-red-800 font-bold text-xl"
                            >
                              ✕
                            </button>
                          )}
                          <label className="block text-sm font-bold text-gray-700 mb-2">
                            Inventor {idx + 1} Name
                          </label>
                          <input
                            type="text"
                            placeholder="Full name of inventor to be added"
                            className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
                            value={inventor.name}
                            onChange={(e) => handleInventorChange(idx, e.target.value)}
                          />
                        </div>
                      ))}
                    </div>
                  ) : (
                    <>
                      <div>
                        <label className="block text-base font-bold text-gray-800 mb-3">
                          Name of Inventor to REMOVE <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Full name of person who should NOT be mentioned as inventor"
                          className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                          value={inventorName}
                          onChange={(e) => setInventorName(e.target.value)}
                        />
                      </div>
                    </>
                  )}

                  {/* Common Form 8 fields */}
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patent/Application Number <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g., 202010012345"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                      value={patentNo8}
                      onChange={(e) => setPatentNo8(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Application Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                      value={applicationDate8}
                      onChange={(e) => setApplicationDate8(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Made By {declarationType === "state_claim" ? "(for ADD)" : "(for REMOVE)"}
                    </label>
                    <input
                      type="text"
                      placeholder="Person who made the original application"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                      value={declarationType === "state_claim" ? madeBy : madeByDeclare}
                      onChange={(e) =>
                        declarationType === "state_claim"
                          ? setMadeBy(e.target.value)
                          : setMadeByDeclare(e.target.value)
                      }
                    />
                  </div>


                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Request Date <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="date"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                        value={requestDate8}
                        onChange={(e) => setRequestDate8(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Name of Person Who Signed <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Full name of person signing"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                        value={signedPersonName8}
                        onChange={(e) => setSignedPersonName8(e.target.value)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Form 7A Specific Fields */}
            {needsForm7AFields && (
              <div className="bg-lime-50 border-l-4 border-lime-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-lime-900 mb-6">
                  📝 Form 7A: Representation for Opposition to Grant of Patent
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={applicationNo7A}
                    onChange={(e) => setApplicationNo7A(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={applicationDate7A}
                    onChange={(e) => setApplicationDate7A(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Made By <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of person making opposition"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={madeBy7A}
                    onChange={(e) => setMadeBy7A(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Published On <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={publishedOn}
                    onChange={(e) => setPublishedOn(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grounds of Opposition <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Detailed grounds for opposition"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={grounds}
                    onChange={(e) => setGrounds(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={signedPersonName7A}
                    onChange={(e) => setSignedPersonName7A(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 8A Specific Fields */}
            {needsForm8AFields && (
              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-amber-900 mb-6">
                  📝 Form 8A: Certificate of Inventorship
                </h2>

                {/* Certificate Type Selection */}
                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Certificate Type <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={certificateType}
                    onChange={(e) => setCertificateType(e.target.value)}
                  >
                    <option value="original">
                      Request for Original Certificate of Inventorship
                    </option>
                    <option value="duplicate">
                      Request for Duplicate Certificate of Inventorship
                    </option>
                  </select>
                  
                  {certificateType === "original" && (
                    <p className="mt-3 text-sm text-blue-800 bg-blue-100 p-4 rounded-lg font-medium">
                      📝 You are requesting <strong>an original certificate</strong> of inventorship.
                    </p>
                  )}
                  {certificateType === "duplicate" && (
                    <p className="mt-3 text-sm text-orange-800 bg-orange-100 p-4 rounded-lg font-medium">
                      🔄 You are requesting <strong>a duplicate certificate</strong> because the original was lost, destroyed, or damaged.
                    </p>
                  )}
                </div>

                {/* Show fields based on certificate type */}
                {certificateType === "original" ? (
                  <>
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Inventor Name <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Full name of inventor"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                        value={inventor}
                        onChange={(e) => setInventor(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Patent/Application Number <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Patent or application number"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                        value={patentNumber}
                        onChange={(e) => setPatentNumber(e.target.value)}
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Inventor Name <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Full name of inventor from lost certificate"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                        value={inventorOr}
                        onChange={(e) => setInventorOr(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Patent/Application Number <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Patent number from lost certificate"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                        value={patentNumberOr}
                        onChange={(e) => setPatentNumberOr(e.target.value)}
                      />
                    </div>
                  </>
                )}

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Aadhaar Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="12-digit Aadhaar number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={aadhaarNumber}
                    onChange={(e) => setAadhaarNumber(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      House No. <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="House/Building number"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={houseNo}
                      onChange={(e) => setHouseNo(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Apartment/Street <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Apartment/Street name"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={apartmentStreet}
                      onChange={(e) => setApartmentStreet(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      City <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="City"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={city}
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      State <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="State"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={state}
                      onChange={(e) => setState(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Country <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Country"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Pincode <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Pincode"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={pincode}
                      onChange={(e) => setPincode(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Mobile Phone <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="tel"
                      placeholder="Mobile number"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={mobilePhone}
                      onChange={(e) => setMobilePhone(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Email <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="email"
                      placeholder="Email address"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                  />
                  <p className="mt-1 text-xs text-gray-500">This will be formatted as "6th day of July, 2026" in the document</p>
                </div>

                {/* Name of Inventor Who Signed */}
                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Inventor Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of inventor who signed this form"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={inventorSigned}
                    onChange={(e) => setInventorSigned(e.target.value)}
                  />
                  <p className="mt-2 text-sm text-gray-600">
                    This may be the same as or different from the inventor name above
                  </p>
                </div>
              </div>
            )}

            {/* Form 9 Specific Fields */}
            {needsForm9Fields && (
              <div className="bg-fuchsia-50 border-l-4 border-fuchsia-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-fuchsia-900 mb-6">
                  📝 Form 9: Request for Publication
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent/Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent or application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-fuchsia-400 shadow-sm"
                    value={patentNo9}
                    onChange={(e) => setPatentNo9(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patent Application Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-fuchsia-400 shadow-sm"
                      value={date9}
                      onChange={(e) => setDate9(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-gray-600">
                      Date when the original patent application was filed
                    </p>
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Request Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-fuchsia-400 shadow-sm"
                      value={requestDate9}
                      onChange={(e) => setRequestDate9(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-gray-600">
                      Date of filing this Form 9 request (today's date)
                    </p>
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-fuchsia-400 shadow-sm"
                    value={signedPersonName9}
                    onChange={(e) => setSignedPersonName9(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 10 Specific Fields */}
            {needsForm10Fields && (
              <div className="bg-rose-50 border-l-4 border-rose-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-rose-900 mb-6">
                  📝 Form 10: Application for Amendment of Patent
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent/Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent or application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={patentNo10}
                    onChange={(e) => setPatentNo10(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={date10}
                    onChange={(e) => setDate10(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Granted To <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of patent holder"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={grantedTo}
                    onChange={(e) => setGrantedTo(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={signedPersonName10}
                    onChange={(e) => setSignedPersonName10(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 11 Specific Fields */}
            {needsForm11Fields && (
              <div className="bg-cyan-50 border-l-4 border-cyan-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-cyan-900 mb-6">
                  📝 Form 11: Application for Direction of the Controller
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent/Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent or application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={patentNo11}
                    onChange={(e) => setPatentNo11(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patent Grant Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                      value={patentDate11}
                      onChange={(e) => setPatentDate11(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-gray-600">
                      Date when the patent was originally granted
                    </p>
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Request Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                      value={date11}
                      onChange={(e) => setDate11(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-gray-600">
                      Date of filing this Form 11 request (usually today)
                    </p>
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grant To <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of grantee"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={grantTo}
                    onChange={(e) => setGrantTo(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Reason for Direction Request <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Detailed reason for requesting Controller's direction"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={signedPersonName11}
                    onChange={(e) => setSignedPersonName11(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 12 Specific Fields */}
            {needsForm12Fields && (
              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-red-900 mb-6">
                  📝 Form 12: Request for Grant of Patent Under Section 26(1) & 52(2)
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    High Court Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of High Court"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={highCourtName}
                    onChange={(e) => setHighCourtName(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patent Number <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Patent number"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                      value={patentNo12}
                      onChange={(e) => setPatentNo12(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patent Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                      value={patentDate12}
                      onChange={(e) => setPatentDate12(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Grantee Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Name of grantee"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                      value={granteeName12}
                      onChange={(e) => setGranteeName12(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Patentee Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Name of patentee"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                      value={patenteeName12}
                      onChange={(e) => setPatenteeName12(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Opposition Date
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                      value={oppositionDate}
                      onChange={(e) => setOppositionDate(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Petition Number
                    </label>
                    <input
                      type="text"
                      placeholder="Petition number (if applicable)"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                      value={petitionNo}
                      onChange={(e) => setPetitionNo(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Petition Date
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={petitionDate}
                    onChange={(e) => setPetitionDate(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Inventor Name
                  </label>
                  <input
                    type="text"
                    placeholder="Name of true and first inventor"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={inventorNameForm12}
                    onChange={(e) => setInventorNameForm12(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Excluded Claims
                  </label>
                  <textarea
                    placeholder="Claims to be excluded"
                    rows="2"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={excludedClaims}
                    onChange={(e) => setExcludedClaims(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    True Inventor Name
                  </label>
                  <input
                    type="text"
                    placeholder="Name of true and first inventor"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={trueInventorName}
                    onChange={(e) => setTrueInventorName(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    True Inventor Address
                  </label>
                  <textarea
                    placeholder="Complete address of true inventor"
                    rows="2"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={trueInventorAddress}
                    onChange={(e) => setTrueInventorAddress(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    True Inventor Nationality
                  </label>
                  <input
                    type="text"
                    placeholder="Nationality"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={trueInventorNationality}
                    onChange={(e) => setTrueInventorNationality(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={date12}
                    onChange={(e) => setDate12(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={signedPersonName12}
                    onChange={(e) => setSignedPersonName12(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 13 Specific Fields */}
            {needsForm13Fields && (
              <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-orange-900 mb-6">
                  📝 Form 13: Application for Amendment
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent/Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent or application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={patentNo13}
                    onChange={(e) => setPatentNo13(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={applicationDate13}
                    onChange={(e) => setApplicationDate13(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Reason for Amendment <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Detailed reason for requesting this amendment"
                    rows="6"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={amendmentReason}
                    onChange={(e) => setAmendmentReason(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={date13}
                    onChange={(e) => setDate13(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={signedPersonName13}
                    onChange={(e) => setSignedPersonName13(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 14 Specific Fields */}
            {needsForm14Fields && (
              <div className="bg-pink-50 border-l-4 border-pink-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-pink-900 mb-6">
                  📝 Form 14: Notice of Opposition
                </h2>

                {/* Opposition Type Selection */}
                <div className="bg-pink-100 border-3 border-pink-300 rounded-xl p-5 shadow-md mb-6">
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Opposition Type <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={oppositionType}
                    onChange={(e) => setOppositionType(e.target.value)}
                  >
                    <option value="amendment">Amendment of Application/Specification</option>
                    <option value="restoration">Restoration of Patent</option>
                    <option value="surrender">Surrender of Patent</option>
                    <option value="compulsory_license">Grant of Compulsory License</option>
                    <option value="license_revision">Revision of License Terms</option>
                    <option value="clerical_error">Correction of Clerical Error</option>
                  </select>

                  <p className="mt-3 text-sm text-pink-800 bg-pink-100 p-3 rounded-lg font-medium">
                    {oppositionType === "amendment" && "🔧 Opposition to amendment of application/specification"}
                    {oppositionType === "restoration" && "🔄 Opposition to restoration of patent"}
                    {oppositionType === "surrender" && "📤 Opposition to surrender of patent"}
                    {oppositionType === "compulsory_license" && "⚖️ Opposition to grant of compulsory license"}
                    {oppositionType === "license_revision" && "📝 Opposition to revision of license terms"}
                    {oppositionType === "clerical_error" && "✏️ Opposition to correction of clerical error"}
                  </p>
                </div>

                {/* Opponent(s) Section */}
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <label className="text-base font-bold text-gray-800">
                      Opponent(s) <span className="text-red-600">*</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setOpponents([...opponents, { name: "", nationality: "", country: "", address: "" }])}
                      className="px-5 py-2 bg-pink-600 text-white rounded-xl hover:bg-pink-700 transition-colors font-bold text-base shadow-md hover:shadow-lg"
                    >
                      + Add Opponent
                    </button>
                  </div>

                  <div className="space-y-5">
                    {opponents.map((opponent, index) => (
                      <div
                        key={index}
                        className="bg-gray-50 p-5 rounded-xl mb-4 border-2 border-gray-200 relative shadow-sm"
                      >
                        {opponents.length > 1 && (
                          <button
                            type="button"
                            onClick={() => setOpponents(opponents.filter((_, i) => i !== index))}
                            className="absolute top-3 right-3 text-red-600 hover:text-red-800 font-bold text-xl"
                            title="Remove opponent"
                          >
                            ✕
                          </button>
                        )}

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <div className="md:col-span-2">
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Name <span className="text-red-600">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Opponent name"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-pink-500"
                              value={opponent.name}
                              onChange={(e) => {
                                const updated = [...opponents];
                                updated[index].name = e.target.value;
                                setOpponents(updated);
                              }}
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Nationality <span className="text-red-600">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="IN"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-pink-500"
                              value={opponent.nationality}
                              onChange={(e) => {
                                const updated = [...opponents];
                                updated[index].nationality = e.target.value;
                                setOpponents(updated);
                              }}
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Country <span className="text-red-600">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="India"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-pink-500"
                              value={opponent.country}
                              onChange={(e) => {
                                const updated = [...opponents];
                                updated[index].country = e.target.value;
                                setOpponents(updated);
                              }}
                            />
                          </div>

                          <div className="md:col-span-2">
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Address <span className="text-red-600">*</span>
                            </label>
                            <textarea
                              rows="2"
                              placeholder="Complete address"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-pink-500"
                              value={opponent.address}
                              onChange={(e) => {
                                const updated = [...opponents];
                                updated[index].address = e.target.value;
                                setOpponents(updated);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={patentNo14}
                    onChange={(e) => setPatentNo14(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={patentDate14}
                    onChange={(e) => setPatentDate14(e.target.value)}
                  />
                </div>

                {/* Conditional fields for clerical_error type */}
                {oppositionType === "clerical_error" && (
                  <>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-base font-bold text-gray-800 mb-3">
                          Specification Number
                        </label>
                        <input
                          type="text"
                          placeholder="Specification number"
                          className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                          value={specificationNo}
                          onChange={(e) => setSpecificationNo(e.target.value)}
                        />
                      </div>

                      <div>
                        <label className="block text-base font-bold text-gray-800 mb-3">
                          Specification Date
                        </label>
                        <input
                          type="date"
                          className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                          value={specificationDate}
                          onChange={(e) => setSpecificationDate(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-base font-bold text-gray-800 mb-3">
                          Related Patent Number
                        </label>
                        <input
                          type="text"
                          placeholder="Related patent number"
                          className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                          value={patentNoRelated}
                          onChange={(e) => setPatentNoRelated(e.target.value)}
                        />
                      </div>

                      <div>
                        <label className="block text-base font-bold text-gray-800 mb-3">
                          Related Patent Date
                        </label>
                        <input
                          type="date"
                          className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                          value={patentDateRelated}
                          onChange={(e) => setPatentDateRelated(e.target.value)}
                        />
                      </div>
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Application Number
                      </label>
                      <input
                        type="text"
                        placeholder="Application number"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                        value={applicationNo14}
                        onChange={(e) => setApplicationNo14(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Application Date
                      </label>
                      <input
                        type="date"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                        value={applicationDate14}
                        onChange={(e) => setApplicationDate14(e.target.value)}
                      />
                    </div>
                  </>
                )}

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grounds for Opposition <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Detailed grounds for this opposition"
                    rows="6"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={oppositionGrounds}
                    onChange={(e) => setOppositionGrounds(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={date14}
                    onChange={(e) => setDate14(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={signedPersonName14}
                    onChange={(e) => setSignedPersonName14(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 15 Specific Fields */}
            {needsForm15Fields && (
              <div className="bg-emerald-50 border-l-4 border-emerald-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-emerald-900 mb-6">
                  📝 Form 15: Application for Restoration of Patent
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                    value={patentNo15}
                    onChange={(e) => setPatentNo15(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                    value={patentDate15}
                    onChange={(e) => setPatentDate15(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Granted To <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of patent holder"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                    value={grantedTo}
                    onChange={(e) => setGrantedTo(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Renewal Year <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Year (e.g., 2024)"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                      value={renewalYear}
                      onChange={(e) => setRenewalYear(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Due Date <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="date"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                      value={dueDate}
                      onChange={(e) => setDueDate(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Circumstances Leading to Failure <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Explain the circumstances that led to failure to pay the renewal fee"
                    rows="6"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                    value={failureCircumstances}
                    onChange={(e) => setFailureCircumstances(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                    value={date15}
                    onChange={(e) => setDate15(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-emerald-400 shadow-sm"
                    value={signedPersonName15}
                    onChange={(e) => setSignedPersonName15(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 6 Specific Fields */}
            {needsForm6Fields && (
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-blue-900 mb-6">
                  📝 Form 6: Claim or Request Regarding Change in Applicant
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={patentNo6}
                    onChange={(e) => setPatentNo6(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={applicationDate6}
                    onChange={(e) => setApplicationDate6(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Original Applicant Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of original applicant"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={originalApplicantName6}
                    onChange={(e) => setOriginalApplicantName6(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Reason for Request <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Reasons for making the above request"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={reason6}
                    onChange={(e) => setReason6(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Documents Description <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Details of documents submitted in support"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={documentsDescription6}
                    onChange={(e) => setDocumentsDescription6(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={date6}
                    onChange={(e) => setDate6(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-blue-400 shadow-sm"
                    value={signedPersonName6}
                    onChange={(e) => setSignedPersonName6(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 7 Specific Fields */}
            {needsForm7Fields && (
              <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-purple-900 mb-6">
                  📝 Form 7: Notice of Opposition (Post-Grant)
                </h2>

                {/* Opponent(s) Section */}
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <label className="text-base font-bold text-gray-800">
                      Opponent(s) <span className="text-red-600">*</span>
                    </label>
                    <button
                      type="button"
                      onClick={() => setOpponents7([...opponents7, { name: "", nationality: "", country: "", address: "" }])}
                      className="px-5 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition-colors font-bold text-base shadow-md hover:shadow-lg"
                    >
                      + Add Opponent
                    </button>
                  </div>

                  <div className="space-y-5">
                    {opponents7.map((opponent, index) => (
                      <div
                        key={index}
                        className="bg-gray-50 p-5 rounded-xl mb-4 border-2 border-gray-200 relative shadow-sm"
                      >
                        {opponents7.length > 1 && (
                          <button
                            type="button"
                            onClick={() => setOpponents7(opponents7.filter((_, i) => i !== index))}
                            className="absolute top-3 right-3 text-red-600 hover:text-red-800 font-bold text-xl"
                            title="Remove opponent"
                          >
                            ✕
                          </button>
                        )}

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                          <div className="md:col-span-2">
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Name <span className="text-red-600">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="Opponent name"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                              value={opponent.name}
                              onChange={(e) => {
                                const updated = [...opponents7];
                                updated[index].name = e.target.value;
                                setOpponents7(updated);
                              }}
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Nationality <span className="text-red-600">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="IN"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                              value={opponent.nationality}
                              onChange={(e) => {
                                const updated = [...opponents7];
                                updated[index].nationality = e.target.value;
                                setOpponents7(updated);
                              }}
                            />
                          </div>

                          <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Country <span className="text-red-600">*</span>
                            </label>
                            <input
                              type="text"
                              placeholder="India"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                              value={opponent.country}
                              onChange={(e) => {
                                const updated = [...opponents7];
                                updated[index].country = e.target.value;
                                setOpponents7(updated);
                              }}
                            />
                          </div>

                          <div className="md:col-span-2">
                            <label className="block text-sm font-bold text-gray-700 mb-2">
                              Address <span className="text-red-600">*</span>
                            </label>
                            <textarea
                              rows="2"
                              placeholder="Complete address"
                              className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-purple-500"
                              value={opponent.address}
                              onChange={(e) => {
                                const updated = [...opponents7];
                                updated[index].address = e.target.value;
                                setOpponents7(updated);
                              }}
                            />
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={patentNo7}
                    onChange={(e) => setPatentNo7(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={applicationNo7}
                    onChange={(e) => setApplicationNo7(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={applicationDate7}
                    onChange={(e) => setApplicationDate7(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Published On <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={publishedOn7}
                    onChange={(e) => setPublishedOn7(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Made By (Original Applicant/Patentee) <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of person who made the patent application"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={madeBy7}
                    onChange={(e) => setMadeBy7(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grounds for Opposition <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="State the grounds taken one after another"
                    rows="5"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={grounds7}
                    onChange={(e) => setGrounds7(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={date7}
                    onChange={(e) => setDate7(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={signedPersonName7}
                    onChange={(e) => setSignedPersonName7(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 16 Specific Fields */}
            {needsForm16Fields && (
              <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-indigo-900 mb-6">
                  📝 Form 16: Registration of Title/Interest in Patent
                </h2>

                <div className="bg-indigo-100 border-3 border-indigo-300 rounded-xl p-5 shadow-md mb-6">
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Type of Registration <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={registrationType16}
                    onChange={(e) => setRegistrationType16(e.target.value)}
                  >
                    <option value="transfer">Registration of Title (Transfer/Assignment)</option>
                    <option value="interest">Registration of Interest/Document</option>
                  </select>

                  <p className="mt-3 text-sm text-indigo-800 bg-indigo-100 p-3 rounded-lg font-medium">
                    {registrationType16 === "transfer" && "📄 Register transfer of patent title/ownership with certified document"}
                    {registrationType16 === "interest" && "📋 Register interest or document affecting proprietorship"}
                  </p>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={patentNo16}
                    onChange={(e) => setPatentNo16(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={patentDate16}
                    onChange={(e) => setPatentDate16(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grantee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of grantee"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={granteeName16}
                    onChange={(e) => setGranteeName16(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patentee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of patentee"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={patenteeName16}
                    onChange={(e) => setPatenteeName16(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Document Type <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Type of document (e.g., Assignment, License)"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={documentType16}
                    onChange={(e) => setDocumentType16(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={date16}
                    onChange={(e) => setDate16(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={signedPersonName16}
                    onChange={(e) => setSignedPersonName16(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 17 Specific Fields */}
            {needsForm17Fields && (
              <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-orange-900 mb-6">
                  📝 Form 17: Application for Compulsory Licence
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={patentNo17}
                    onChange={(e) => setPatentNo17(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={patentDate17}
                    onChange={(e) => setPatentDate17(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Granted To <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name to whom patent was granted"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={granteeName17}
                    onChange={(e) => setGranteeName17(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patentee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Current patentee name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={patenteeName17}
                    onChange={(e) => setPatenteeName17(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grounds for Compulsory Licence <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="State the grounds for seeking compulsory licence"
                    rows="5"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={grounds17}
                    onChange={(e) => setGrounds17(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Documentary Evidence <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Details of documentary evidence in support"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={documentaryEvidence17}
                    onChange={(e) => setDocumentaryEvidence17(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={date17}
                    onChange={(e) => setDate17(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={signedPersonName17}
                    onChange={(e) => setSignedPersonName17(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 18 Specific Fields */}
            {needsForm18Fields && (
              <div className="bg-cyan-50 border-l-4 border-cyan-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-cyan-900 mb-6">
                  📝 Form 18: Request for Examination
                </h2>

                {/* Examination Type Selection */}
                <div className="bg-cyan-100 border-3 border-cyan-300 rounded-xl p-5 shadow-md mb-6">
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Examination Type <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={examinationType18}
                    onChange={(e) => setExaminationType18(e.target.value)}
                  >
                    <option value="normal">Normal Request by Applicant</option>
                    <option value="pct">Express Request (PCT Application)</option>
                    <option value="interested_person">Request by Interested Person</option>
                  </select>

                  <p className="mt-3 text-sm text-cyan-800 bg-cyan-100 p-3 rounded-lg font-medium">
                    {examinationType18 === "normal" && "📝 Standard examination request by applicant"}
                    {examinationType18 === "pct" && "🌐 Express request based on PCT application"}
                    {examinationType18 === "interested_person" && "👤 Examination request by interested person"}
                  </p>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={patentNo18}
                    onChange={(e) => setPatentNo18(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={applicationDate18}
                    onChange={(e) => setApplicationDate18(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Invention Title <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Title of the invention"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={inventionTitle18}
                    onChange={(e) => setInventionTitle18(e.target.value)}
                  />
                </div>

                {/* PCT Fields (only if PCT selected) */}
                {examinationType18 === "pct" && (
                  <>
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        PCT Application Number <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="PCT application number"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                        value={pctApplicationNo18}
                        onChange={(e) => setPctApplicationNo18(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        PCT Filing Date <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="date"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                        value={pctFilingDate18}
                        onChange={(e) => setPctFilingDate18(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        PCT Country <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Country where PCT was made"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                        value={pctCountry18}
                        onChange={(e) => setPctCountry18(e.target.value)}
                      />
                    </div>
                  </>
                )}

                {/* Interested Person Fields (only if interested_person selected) */}
                {examinationType18 === "interested_person" && (
                  <>
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Interested Person Name <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Name of interested person"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                        value={interestedPersonName18}
                        onChange={(e) => setInterestedPersonName18(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Evidence Documents <span className="text-red-600">*</span>
                      </label>
                      <textarea
                        placeholder="Evidence of interest in the application"
                        rows="4"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                        value={evidenceDocuments18}
                        onChange={(e) => setEvidenceDocuments18(e.target.value)}
                      />
                    </div>
                  </>
                )}


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={date18}
                    onChange={(e) => setDate18(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={signedPersonName18}
                    onChange={(e) => setSignedPersonName18(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 18A Specific Fields */}
            {needsForm18AFields && (
              <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-teal-900 mb-6">
                  📝 Form 18A: Request for Expedited Examination
                </h2>

                {/* Expedited Type Selection */}
                <div className="bg-teal-100 border-3 border-teal-300 rounded-xl p-5 shadow-md mb-6">
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Request Type <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={expeditedType18A}
                    onChange={(e) => setExpeditedType18A(e.target.value)}
                  >
                    <option value="normal">New Expedited Request</option>
                    <option value="pct">Expedited Request (PCT Application)</option>
                    <option value="conversion">Convert Existing Request to Expedited</option>
                  </select>

                  <p className="mt-3 text-sm text-teal-800 bg-teal-100 p-3 rounded-lg font-medium">
                    {expeditedType18A === "normal" && "⚡ New expedited examination request"}
                    {expeditedType18A === "pct" && "🌐 Expedited request based on PCT application"}
                    {expeditedType18A === "conversion" && "🔄 Convert existing Form 18 request to expedited"}
                  </p>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={patentNo18A}
                    onChange={(e) => setPatentNo18A(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={applicationDate18A}
                    onChange={(e) => setApplicationDate18A(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Invention Title <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Title of the invention"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={inventionTitle18A}
                    onChange={(e) => setInventionTitle18A(e.target.value)}
                  />
                </div>

                {/* PCT Fields (only if PCT selected) */}
                {expeditedType18A === "pct" && (
                  <>
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        PCT Application Number <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="PCT application number"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                        value={pctApplicationNo18A}
                        onChange={(e) => setPctApplicationNo18A(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        PCT Filing Date <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="date"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                        value={pctFilingDate18A}
                        onChange={(e) => setPctFilingDate18A(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        PCT Country <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Country where PCT was made"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                        value={pctCountry18A}
                        onChange={(e) => setPctCountry18A(e.target.value)}
                      />
                    </div>
                  </>
                )}

                {/* Conversion Field (only if conversion selected) */}
                {expeditedType18A === "conversion" && (
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Request for Examination Number <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Existing Form 18 request number"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                      value={requestExaminationNo18A}
                      onChange={(e) => setRequestExaminationNo18A(e.target.value)}
                    />
                  </div>
                )}


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={date18A}
                    onChange={(e) => setDate18A(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={signedPersonName18A}
                    onChange={(e) => setSignedPersonName18A(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 19 Specific Fields */}
            {needsForm19Fields && (
              <div className="bg-rose-50 border-l-4 border-rose-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-rose-900 mb-6">
                  📝 Form 19: Application for Revocation of Patent
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={patentNo19}
                    onChange={(e) => setPatentNo19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={patentDate19}
                    onChange={(e) => setPatentDate19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Granted To <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name to whom patent was granted"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={granteeName19}
                    onChange={(e) => setGranteeName19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patentee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Current patentee/applicant for patent"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={patenteeName19}
                    onChange={(e) => setPatenteeName19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Reason for Revocation <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="State the reason for seeking revocation"
                    rows="5"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={reason19}
                    onChange={(e) => setReason19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Applicant's Interest <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="State the nature of applicant's interest and facts relied upon"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={applicantInterest19}
                    onChange={(e) => setApplicantInterest19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Documentary Evidence <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Details of documentary evidence in support"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={documentaryEvidence19}
                    onChange={(e) => setDocumentaryEvidence19(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={date19}
                    onChange={(e) => setDate19(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={signedPersonName19}
                    onChange={(e) => setSignedPersonName19(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 20 Specific Fields */}
            {needsForm20Fields && (
              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-amber-900 mb-6">
                  📝 Form 20: Application for Revision of Licence Terms
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={patentNo20}
                    onChange={(e) => setPatentNo20(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={patentDate20}
                    onChange={(e) => setPatentDate20(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Granted To <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name to whom patent was granted"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={granteeName20}
                    onChange={(e) => setGranteeName20(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patentee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Current patentee name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={patenteeName20}
                    onChange={(e) => setPatenteeName20(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Licence Grant Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={licenceDate20}
                    onChange={(e) => setLicenceDate20(e.target.value)}
                  />
                  <p className="mt-2 text-sm text-amber-700">
                    Date when Controller granted the licence
                  </p>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={date20}
                    onChange={(e) => setDate20(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={signedPersonName20}
                    onChange={(e) => setSignedPersonName20(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 21 Specific Fields */}
            {needsForm21Fields && (
              <div className="bg-indigo-50 border-l-4 border-indigo-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-indigo-900 mb-6">
                  📝 Form 21: Request for Termination of Compulsory Licence
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Licence Grantee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of the compulsory licensee"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={licenseGranteeName21}
                    onChange={(e) => setLicenseGranteeName21(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Controller Order Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={controllerOrderDate21}
                    onChange={(e) => setControllerOrderDate21(e.target.value)}
                  />
                  <p className="mt-2 text-sm text-indigo-700">
                    Date of Controller's order granting the compulsory license
                  </p>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Number (Under License) <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent number for which license was granted"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={patentNo21Under}
                    onChange={(e) => setPatentNo21Under(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Date (Under License) <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={patentDate21Under}
                    onChange={(e) => setPatentDate21Under(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Original Grantee <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of person to whom patent was originally granted"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={originalGrantee21}
                    onChange={(e) => setOriginalGrantee21(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patentee Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Current patentee name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={patenteeName21}
                    onChange={(e) => setPatenteeName21(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Grounds for Termination <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="State reasons for termination request"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={groundsForTermination21}
                    onChange={(e) => setGroundsForTermination21(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Documentary Evidence <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Details of documentary evidence supporting the request"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={documentaryEvidence21}
                    onChange={(e) => setDocumentaryEvidence21(e.target.value)}
                  />
                </div>


                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={date21}
                    onChange={(e) => setDate21(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-indigo-400 shadow-sm"
                    value={signedPersonName21}
                    onChange={(e) => setSignedPersonName21(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 22 Specific Fields */}
            {needsForm22Fields && (
              <div className="bg-purple-50 border-l-4 border-purple-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-purple-900 mb-6">
                  📝 Form 22: Application for Registration of Patent Agent
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Character Certificate From <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name and designation of person issuing certificate"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={characterCertificateFrom22}
                    onChange={(e) => setCharacterCertificateFrom22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Full Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of applicant"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={fullName22}
                    onChange={(e) => setFullName22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Address/Place of Residence <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Full residential address"
                    rows="2"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={addressResidence22}
                    onChange={(e) => setAddressResidence22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Principal Place of Business <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Principal place where business is conducted"
                    rows="2"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={principalPlaceBusiness22}
                    onChange={(e) => setPrincipalPlaceBusiness22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Branch Office Address (if any)
                  </label>
                  <textarea
                    placeholder="Address of branch office"
                    rows="2"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={branchOfficeAddress22}
                    onChange={(e) => setBranchOfficeAddress22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Father's Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Father's full name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={fathersName22}
                    onChange={(e) => setFathersName22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Nationality <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Country of nationality"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={nationality22}
                    onChange={(e) => setNationality22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date of Birth <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={dateOfBirth22}
                    onChange={(e) => setDateOfBirth22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Place of Birth <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="City/town of birth"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={placeOfBirth22}
                    onChange={(e) => setPlaceOfBirth22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Occupation <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Current occupation"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={occupation22}
                    onChange={(e) => setOccupation22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Qualifications for Patent Agent Registration <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Details of qualifications and experience"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={qualifications22}
                    onChange={(e) => setQualifications22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={date22}
                    onChange={(e) => setDate22(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-purple-400 shadow-sm"
                    value={signedPersonName22}
                    onChange={(e) => setSignedPersonName22(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 23 Specific Fields */}
            {needsForm23Fields && (
              <div className="bg-pink-50 border-l-4 border-pink-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-pink-900 mb-6">
                  📝 Form 23: Application for Restoration of Name in Register of Patent Agents
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Full Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name as recorded in register"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={fullName23}
                    onChange={(e) => setFullName23(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date of Removal from Register <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={removalDate23}
                    onChange={(e) => setRemovalDate23(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Original Entry Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={originalEntryDate23}
                    onChange={(e) => setOriginalEntryDate23(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Registration Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Registration number in the register"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={registrationNumber23}
                    onChange={(e) => setRegistrationNumber23(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={date23}
                    onChange={(e) => setDate23(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-pink-400 shadow-sm"
                    value={signedPersonName23}
                    onChange={(e) => setSignedPersonName23(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 24 Specific Fields */}
            {needsForm24Fields && (
              <div className="bg-red-50 border-l-4 border-red-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-red-900 mb-6">
                  📝 Form 24: Application for Review/Setting Aside Controller's Decision
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent or Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent or application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={patentOrApplicationNo24}
                    onChange={(e) => setPatentOrApplicationNo24(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Relevant Proceeding <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Description of the matter/proceeding"
                    rows="3"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={relevantProceeding24}
                    onChange={(e) => setRelevantProceeding24(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Controller's Decision Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={controllerDecisionDate24}
                    onChange={(e) => setControllerDecisionDate24(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={date24}
                    onChange={(e) => setDate24(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name of person signing"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-red-400 shadow-sm"
                    value={signedPersonName24}
                    onChange={(e) => setSignedPersonName24(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 25 Specific Fields */}
            {needsForm25Fields && (
              <div className="bg-orange-50 border-l-4 border-orange-500 p-6 rounded-lg">
                <h2 className="text-2xl font-bold text-orange-900 mb-6">
                  📝 Form 25: Permission for Making Patent Application Outside India
                </h2>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Invention Title <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Title of the invention"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={inventionTitle25}
                    onChange={(e) => setInventionTitle25(e.target.value)}
                  />
                </div>

                <div className="bg-orange-100 border-3 border-orange-300 rounded-xl p-5 shadow-md mb-6">
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    How to Provide Invention Details <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={hasApplicationOrDescription25}
                    onChange={(e) => setHasApplicationOrDescription25(e.target.value)}
                  >
                    <option value="has_application">Have Indian Patent Application</option>
                    <option value="description">Provide Invention Description</option>
                  </select>
                  <p className="mt-3 text-sm text-orange-800 font-medium">
                    {hasApplicationOrDescription25 === "has_application" 
                      ? "📋 Provide existing Indian patent application details"
                      : "📝 Attach brief description of the invention"}
                  </p>
                </div>

                {hasApplicationOrDescription25 === "has_application" && (
                  <>
                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Indian Patent Application Number <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="text"
                        placeholder="Application number"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                        value={applicationNumber25}
                        onChange={(e) => setApplicationNumber25(e.target.value)}
                      />
                    </div>

                    <div>
                      <label className="block text-base font-bold text-gray-800 mb-3">
                        Application Date <span className="text-red-600">*</span>
                      </label>
                      <input
                        type="date"
                        className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                        value={applicationDate25}
                        onChange={(e) => setApplicationDate25(e.target.value)}
                      />
                    </div>
                  </>
                )}

                {hasApplicationOrDescription25 === "description" && (
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Invention Description <span className="text-red-600">*</span>
                    </label>
                    <textarea
                      placeholder="Brief description of the invention"
                      rows="5"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                      value={inventionDescription25}
                      onChange={(e) => setInventionDescription25(e.target.value)}
                    />
                  </div>
                )}

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Intend to Apply With (if applicable)
                  </label>
                  <input
                    type="text"
                    placeholder="Co-applicants or joint applicants"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={intendToApplyWith25}
                    onChange={(e) => setIntendToApplyWith25(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Target Countries/Convention Countries <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="List of countries where application will be made"
                    rows="3"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={targetCountries25}
                    onChange={(e) => setTargetCountries25(e.target.value)}
                  />
                </div>

                <div className="bg-orange-100 border-3 border-orange-300 rounded-xl p-5 shadow-md mb-6">
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Has Rights Been Assigned <span className="text-red-600">*</span>
                  </label>
                  <select
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={hasBeenAssigned25}
                    onChange={(e) => setHasBeenAssigned25(e.target.value)}
                  >
                    <option value="no">No - Rights with Inventor/Applicant</option>
                    <option value="yes">Yes - Rights Assigned to Someone Else</option>
                  </select>
                </div>

                {hasBeenAssigned25 === "yes" && (
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Assignee Name <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Name of the assignee"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                      value={assigneeName25}
                      onChange={(e) => setAssigneeName25(e.target.value)}
                    />
                  </div>
                )}

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Reasons for Application <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Reasons for making foreign applications"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                    value={reasonsForApplication25}
                    onChange={(e) => setReasonsForApplication25(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 26 Specific Fields */}
            {needsForm26Fields && (
              <div className="bg-teal-50 border-l-4 border-teal-500 p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-teal-700 mb-6">
                  Form 26: Authorisation of Patent Agent
                </h3>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Authorizer Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of person giving authorization"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={authorizerName26}
                    onChange={(e) => setAuthorizerName26(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Authorizer Address <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Complete address"
                    rows="3"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={authorizerAddress26}
                    onChange={(e) => setAuthorizerAddress26(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Authorized Person Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Name of patent agent/person to authorize"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={authorizedPersonName26}
                    onChange={(e) => setAuthorizedPersonName26(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Authorized Person Address <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Complete address"
                    rows="3"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={authorizedPersonAddress26}
                    onChange={(e) => setAuthorizedPersonAddress26(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Matter Description <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Describe the matter/proceeding"
                    rows="3"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={matterDescription26}
                    onChange={(e) => setMatterDescription26(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-teal-400 shadow-sm"
                    value={signedPersonName26}
                    onChange={(e) => setSignedPersonName26(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 27 Specific Fields */}
            {needsForm27Fields && (
              <div className="bg-cyan-50 border-l-4 border-cyan-500 p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-cyan-700 mb-6">
                  Form 27: Statement Regarding Working of Patented Invention
                </h3>

                {/* Patentees Section with Add/Remove */}
                <div className="flex justify-between items-center mb-5">
                  <label className="text-base font-bold text-gray-800">
                    Patentee(s) / Licensee(s) <span className="text-red-600">*</span>
                  </label>
                  <button
                    type="button"
                    onClick={addPatentee27}
                    className="px-5 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition-colors font-bold text-base shadow-md hover:shadow-lg"
                  >
                    + Add Patentee
                  </button>
                </div>

                {patentees27.map((patentee, idx) => (
                  <div
                    key={idx}
                    className="bg-white p-5 rounded-xl mb-4 border-2 border-cyan-200 relative shadow-sm"
                  >
                    {patentees27.length > 1 && (
                      <button
                        type="button"
                        onClick={() => removePatentee27(idx)}
                        className="absolute top-3 right-3 text-red-600 hover:text-red-800 font-bold text-xl"
                        title="Remove patentee"
                      >
                        ✕
                      </button>
                    )}

                    <div className="grid grid-cols-1 gap-5">
                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Patentee/Licensee Name <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="Full name of patentee or licensee"
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-cyan-500"
                          value={patentee.name}
                          onChange={(e) =>
                            handlePatentee27Change(idx, "name", e.target.value)
                          }
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Nationality <span className="text-red-600">*</span>
                        </label>
                        <input
                          type="text"
                          placeholder="e.g., Indian, American, etc."
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-cyan-500"
                          value={patentee.nationality}
                          onChange={(e) =>
                            handlePatentee27Change(idx, "nationality", e.target.value)
                          }
                        />
                      </div>

                      <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">
                          Address <span className="text-red-600">*</span>
                        </label>
                        <textarea
                          placeholder="Complete address"
                          rows="3"
                          className="w-full border-2 border-gray-300 p-3 rounded-lg text-base font-medium focus:outline-none focus:ring-2 focus:ring-cyan-500"
                          value={patentee.address}
                          onChange={(e) =>
                            handlePatentee27Change(idx, "address", e.target.value)
                          }
                        />
                      </div>
                    </div>
                  </div>
                ))}

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Patent Numbers <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., 12345, 67890"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={patentNumbers27}
                    onChange={(e) => setPatentNumbers27(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Financial Year <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., 2024-2025"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={financialYear27}
                    onChange={(e) => setFinancialYear27(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Contact Email
                  </label>
                  <input
                    type="email"
                    placeholder="For licensing inquiries"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={contactEmail27}
                    onChange={(e) => setContactEmail27(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Contact Number
                  </label>
                  <input
                    type="text"
                    placeholder="Phone number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={contactNumber27}
                    onChange={(e) => setContactNumber27(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-cyan-400 shadow-sm"
                    value={date27}
                    onChange={(e) => setDate27(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 29 Specific Fields */}
            {needsForm29Fields && (
              <div className="bg-lime-50 border-l-4 border-lime-500 p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-lime-700 mb-6">
                  Form 29: Request for Withdrawal of Application
                </h3>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={applicationNumber29}
                    onChange={(e) => setApplicationNumber29(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={applicationDate29}
                    onChange={(e) => setApplicationDate29(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Examination Request Number
                  </label>
                  <input
                    type="text"
                    placeholder="If applicable"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={examinationRequestNumber29}
                    onChange={(e) => setExaminationRequestNumber29(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Examination Request Date
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={examinationRequestDate29}
                    onChange={(e) => setExaminationRequestDate29(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={date29}
                    onChange={(e) => setDate29(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={signedPersonName29}
                    onChange={(e) => setSignedPersonName29(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Designation
                  </label>
                  <input
                    type="text"
                    placeholder="e.g., Patent Agent, Applicant"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-lime-400 shadow-sm"
                    value={designation29}
                    onChange={(e) => setDesignation29(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 30 Specific Fields */}
            {needsForm30Fields && (
              <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-amber-700 mb-6">
                  Form 30: General Form
                </h3>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Applicant Name <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={applicantName30}
                    onChange={(e) => setApplicantName30(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      House No. <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="House/Building number"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={houseNo30}
                      onChange={(e) => setHouseNo30(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Street
                    </label>
                    <input
                      type="text"
                      placeholder="Street name"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={street30}
                      onChange={(e) => setStreet30(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      City <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="City"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={city30}
                      onChange={(e) => setCity30(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      State <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="State"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={state30}
                      onChange={(e) => setState30(e.target.value)}
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Country <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Country"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={country30}
                      onChange={(e) => setCountry30(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Pincode <span className="text-red-600">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="Postal code"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={pincode30}
                      onChange={(e) => setPincode30(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Email <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="email"
                    placeholder="Email address"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={email30}
                    onChange={(e) => setEmail30(e.target.value)}
                  />
                </div>

                <div className="grid grid-cols-3 gap-4">
                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Telephone
                    </label>
                    <input
                      type="text"
                      placeholder="Phone"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={telephone30}
                      onChange={(e) => setTelephone30(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Mobile
                    </label>
                    <input
                      type="text"
                      placeholder="Mobile"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={mobile30}
                      onChange={(e) => setMobile30(e.target.value)}
                    />
                  </div>

                  <div>
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Fax
                    </label>
                    <input
                      type="text"
                      placeholder="Fax"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={fax30}
                      onChange={(e) => setFax30(e.target.value)}
                    />
                  </div>
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application/Patent No. <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Application or patent number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={applicationPatentNo30}
                    onChange={(e) => setApplicationPatentNo30(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Relevant Section/Rules <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Section/rule reference"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={relevantSectionRules30}
                    onChange={(e) => setRelevantSectionRules30(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Purpose of Request <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Purpose"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={purposeOfRequest30}
                    onChange={(e) => setPurposeOfRequest30(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Request Details <span className="text-red-600">*</span>
                  </label>
                  <textarea
                    placeholder="Details of the request"
                    rows="4"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={requestDetails30}
                    onChange={(e) => setRequestDetails30(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Name of Person Who Signed <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Full name"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={signedPersonName30}
                    onChange={(e) => setSignedPersonName30(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Designation <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Designation"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                    value={designation30}
                    onChange={(e) => setDesignation30(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Form 31 Specific Fields */}
            {needsForm31Fields && (
              <div className="bg-rose-50 border-l-4 border-rose-500 p-6 rounded-lg">
                <h3 className="text-2xl font-bold text-rose-700 mb-6">
                  Form 31: Grace Period
                </h3>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Number <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="text"
                    placeholder="Patent application number"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={applicationNumber31}
                    onChange={(e) => setApplicationNumber31(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Application Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={applicationDate31}
                    onChange={(e) => setApplicationDate31(e.target.value)}
                  />
                </div>

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Applicable Grace Provision Sections <span className="text-red-600">*</span>
                  </label>
                  <div className="space-y-3 bg-white p-4 rounded-lg border-2 border-rose-200">
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="section31a"
                        checked={selectedGraceSections31.includes("31a")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedGraceSections31([...selectedGraceSections31, "31a"]);
                          } else {
                            setSelectedGraceSections31(selectedGraceSections31.filter(s => s !== "31a"));
                          }
                        }}
                        className="w-5 h-5 text-rose-600 border-gray-300 rounded focus:ring-rose-500"
                      />
                      <label htmlFor="section31a" className="ml-3 text-base font-semibold text-gray-700">
                        Section 31(a) - Display or use at exhibition
                      </label>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="section31b"
                        checked={selectedGraceSections31.includes("31b")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedGraceSections31([...selectedGraceSections31, "31b"]);
                          } else {
                            setSelectedGraceSections31(selectedGraceSections31.filter(s => s !== "31b"));
                          }
                        }}
                        className="w-5 h-5 text-rose-600 border-gray-300 rounded focus:ring-rose-500"
                      />
                      <label htmlFor="section31b" className="ml-3 text-base font-semibold text-gray-700">
                        Section 31(b) - Publication after display
                      </label>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="section31c"
                        checked={selectedGraceSections31.includes("31c")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedGraceSections31([...selectedGraceSections31, "31c"]);
                          } else {
                            setSelectedGraceSections31(selectedGraceSections31.filter(s => s !== "31c"));
                          }
                        }}
                        className="w-5 h-5 text-rose-600 border-gray-300 rounded focus:ring-rose-500"
                      />
                      <label htmlFor="section31c" className="ml-3 text-base font-semibold text-gray-700">
                        Section 31(c) - Use without consent
                      </label>
                    </div>
                    <div className="flex items-center">
                      <input
                        type="checkbox"
                        id="section31d"
                        checked={selectedGraceSections31.includes("31d")}
                        onChange={(e) => {
                          if (e.target.checked) {
                            setSelectedGraceSections31([...selectedGraceSections31, "31d"]);
                          } else {
                            setSelectedGraceSections31(selectedGraceSections31.filter(s => s !== "31d"));
                          }
                        }}
                        className="w-5 h-5 text-rose-600 border-gray-300 rounded focus:ring-rose-500"
                      />
                      <label htmlFor="section31d" className="ml-3 text-base font-semibold text-gray-700">
                        Section 31(d) - Paper read before learned society
                      </label>
                    </div>
                  </div>
                  <p className="mt-2 text-sm text-rose-700">
                    Select one or more applicable sections (can select multiple)
                  </p>
                </div>

                {/* Section 31(a) Evidence */}
                {selectedGraceSections31.includes("31a") && (
                  <div className="bg-rose-100 p-4 rounded-lg border-2 border-rose-300">
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Documentary Evidence for Section 31(a) <span className="text-red-600">*</span>
                    </label>
                    <textarea
                      placeholder="With reference to: earliest date of display/use, consent of inventor, exhibition details, etc."
                      rows="5"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                      value={evidence31a}
                      onChange={(e) => setEvidence31a(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-rose-800">
                      Include: (a) earliest date of display/use, (b) consent details, (c) exhibition details
                    </p>
                  </div>
                )}

                {/* Section 31(b) Evidence */}
                {selectedGraceSections31.includes("31b") && (
                  <div className="bg-orange-100 p-4 rounded-lg border-2 border-orange-300">
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Documentary Evidence for Section 31(b) <span className="text-red-600">*</span>
                    </label>
                    <textarea
                      placeholder="With reference to: earliest date of publication/use, evidence from 31(a), publication details, etc."
                      rows="5"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-orange-400 shadow-sm"
                      value={evidence31b}
                      onChange={(e) => setEvidence31b(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-orange-800">
                      Include: (a) earliest publication date, (b) reference to 31(a) evidence, (c) publication consequence details
                    </p>
                  </div>
                )}

                {/* Section 31(c) Evidence */}
                {selectedGraceSections31.includes("31c") && (
                  <div className="bg-amber-100 p-4 rounded-lg border-2 border-amber-300">
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Documentary Evidence for Section 31(c) <span className="text-red-600">*</span>
                    </label>
                    <textarea
                      placeholder="With reference to: earliest date of use, evidence from 31(a)/31(b), use details, affidavit of use without consent, etc."
                      rows="5"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-amber-400 shadow-sm"
                      value={evidence31c}
                      onChange={(e) => setEvidence31c(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-amber-800">
                      Include: (a) earliest use date, (b) reference to 31(a)/31(b), (c) use details, (d) affidavit that use occurred without consent
                    </p>
                  </div>
                )}

                {/* Section 31(d) Evidence */}
                {selectedGraceSections31.includes("31d") && (
                  <div className="bg-yellow-100 p-4 rounded-lg border-2 border-yellow-300">
                    <label className="block text-base font-bold text-gray-800 mb-3">
                      Documentary Evidence for Section 31(d) <span className="text-red-600">*</span>
                    </label>
                    <textarea
                      placeholder="With reference to: earliest date of description/publication, paper details before learned society, publication details, etc."
                      rows="5"
                      className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-yellow-400 shadow-sm"
                      value={evidence31d}
                      onChange={(e) => setEvidence31d(e.target.value)}
                    />
                    <p className="mt-2 text-sm text-yellow-800">
                      Include: (a) earliest description date, (b) paper read details, (c) publication by/with consent of inventor
                    </p>
                  </div>
                )}

                <div>
                  <label className="block text-base font-bold text-gray-800 mb-3">
                    Date <span className="text-red-600">*</span>
                  </label>
                  <input
                    type="date"
                    className="w-full border-3 border-gray-400 p-4 rounded-xl text-lg font-medium focus:outline-none focus:ring-4 focus:ring-rose-400 shadow-sm"
                    value={date31}
                    onChange={(e) => setDate31(e.target.value)}
                  />
                </div>
              </div>
            )}

            {/* Download Buttons - Always Visible (like Form135) */}
            <div className="text-center pt-6 space-y-4">
              {/* Single Form: Show individual button only (Form135 style) */}
              {selectedForms.length === 1 && (
                <button
                  className={`bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 mt-4 mx-auto text-lg font-semibold shadow transition w-full md:w-1/2 ${
                    (!isFormValid() || loading) ? "opacity-50 cursor-not-allowed" : ""
                  }`}
                  onClick={() => handleIndividualDownload(selectedForms[0])}
                  disabled={!isFormValid() || loading}
                  aria-disabled={!isFormValid() || loading}
                  style={{ pointerEvents: (!isFormValid() || loading) ? "none" : undefined }}
                >
                  <div className="flex items-center justify-between w-full">
                    <span className="text-white">
                      {loading ? "⏳ Generating..." : `Download Form${selectedForms[0]}`}
                    </span>
                    <span className="ml-3 bg-white text-sm text-gray-800 px-2 py-1 rounded-full border">
                      {counts[`FORM${selectedForms[0]}.docx`] || 0}
                    </span>
                  </div>
                </button>
              )}

              {/* Multiple Forms: Show Download All + Individual buttons */}
              {selectedForms.length > 1 && (
                <>
                  {/* Primary Button: Download All as ZIP (Form135 style) */}
                  <button
                    className={`bg-gradient-to-r from-green-600 to-teal-600 text-white px-6 py-3 rounded-lg hover:from-green-700 hover:to-teal-700 mt-4 mx-auto text-lg font-semibold shadow transition w-full md:w-1/2 ${
                      (!isFormValid() || loading) ? "opacity-50 cursor-not-allowed" : ""
                    }`}
                    onClick={handleDownload}
                    disabled={!isFormValid() || loading}
                    aria-disabled={!isFormValid() || loading}
                    style={{ pointerEvents: (!isFormValid() || loading) ? "none" : undefined }}
                  >
                    <div className="flex items-center justify-between w-full">
                      <span className="text-white">
                        {loading ? "⏳ Generating All..." : "Download All Forms (ZIP)"}
                      </span>
                      <span className="ml-3 bg-white text-sm text-green-700 px-2 py-1 rounded-full border">
                        {selectedForms.length} forms
                      </span>
                    </div>
                  </button>

                  {/* Divider */}
                  <div className="relative py-4">
                    <div className="absolute inset-0 flex items-center">
                      <div className="w-full border-t-2 border-gray-300"></div>
                    </div>
                    <div className="relative flex justify-center">
                      <span className="bg-white px-4 text-gray-600 font-semibold">
                        Or download individually:
                      </span>
                    </div>
                  </div>

                  {/* Individual Download Buttons (Form135 style - colored backgrounds) */}
                  <div className="grid grid-cols-1 gap-3">
                    {selectedForms.map((formNumber, index) => {
                      // Cycle through colors like Form135: blue, purple, teal
                      const colors = [
                        { bg: 'bg-blue-600', hover: 'hover:bg-blue-700', textColor: 'text-gray-800' },
                        { bg: 'bg-purple-600', hover: 'hover:bg-purple-700', textColor: 'text-gray-800' },
                        { bg: 'bg-teal-600', hover: 'hover:bg-teal-700', textColor: 'text-gray-800' }
                      ];
                      const colorScheme = colors[index % colors.length];
                      
                      return (
                        <button
                          key={formNumber}
                          className={`${colorScheme.bg} text-white px-6 py-3 rounded-lg ${colorScheme.hover} text-lg font-semibold shadow transition w-full ${
                            (!isFormValid() || loading) ? "opacity-50 cursor-not-allowed" : ""
                          }`}
                          onClick={() => handleIndividualDownload(formNumber)}
                          disabled={!isFormValid() || loading}
                          aria-disabled={!isFormValid() || loading}
                          style={{ pointerEvents: (!isFormValid() || loading) ? "none" : undefined }}
                        >
                          <div className="flex items-center justify-between w-full">
                            <span className="text-white">Download Form{formNumber}</span>
                            <span className={`ml-3 bg-white text-sm ${colorScheme.textColor} px-2 py-1 rounded-full border`}>
                              {counts[`FORM${formNumber}.docx`] || 0}
                            </span>
                          </div>
                        </button>
                      );
                    })}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default UnifiedFormPage;
